// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__Math = require("@rescript/core/src/Core__Math.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.res.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.res.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.res.js");
var MM_wrk_settings = require("./MM_wrk_settings.res.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var MM_proof_tree_dto = require("../mm-utils/MM_proof_tree_dto.res.js");
var MM_proof_verifier = require("../mm-utils/MM_proof_verifier.res.js");
var MM_statements_dto = require("../mm-utils/MM_statements_dto.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_unification_debug = require("../mm-utils/MM_unification_debug.res.js");
var Belt_MutableMapString = require("rescript/lib/js/belt_MutableMapString.js");

function contIsEmpty(cont) {
  if (cont.TAG === "Text") {
    return cont.text.length === 0;
  } else {
    return cont._0.text.length === 0;
  }
}

function contToArrStr(cont) {
  if (cont.TAG === "Text") {
    return Common.getSpaceSeparatedValuesAsArray(cont.text);
  } else {
    return Common.getSpaceSeparatedValuesAsArray(cont._0.text);
  }
}

function contToStr(cont) {
  if (cont.TAG === "Text") {
    return cont.text;
  } else {
    return cont._0.text;
  }
}

function strToCont(str, preCtxColors, wrkCtxColors) {
  var symsArr = Common.getSpaceSeparatedValuesAsArray(str);
  return {
          TAG: "Text",
          text: symsArr.join(" "),
          syms: symsArr.map(function (sym) {
                var color = Belt_Option.flatMap(preCtxColors, (function (map) {
                        return Belt_HashMapString.get(map, sym);
                      }));
                var tmp;
                if (color !== undefined) {
                  tmp = color;
                } else {
                  var color$1 = Belt_Option.flatMap(wrkCtxColors, (function (map) {
                          return Belt_HashMapString.get(map, sym);
                        }));
                  tmp = color$1 !== undefined ? color$1 : undefined;
                }
                return {
                        sym: sym,
                        color: tmp
                      };
              })
        };
}

function userStmtTypeFromStr(str) {
  switch (str) {
    case "e" :
        return "E";
    case "p" :
        return "P";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to userStmtType"
            },
            Error: new Error()
          };
  }
}

function userStmtTypeToStr(typ) {
  if (typ === "E") {
    return "e";
  } else {
    return "p";
  }
}

function userStmtTypeExtendedFromStrExn(str) {
  switch (str) {
    case "g" :
        return "G";
    case "h" :
        return "H";
    case "p" :
        return "P";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to userStmtTypeExtended. Possible values are h, p, g."
            },
            Error: new Error()
          };
  }
}

function userStmtTypeExtendedToUserStmtType(typExt) {
  switch (typExt) {
    case "H" :
        return [
                "E",
                false
              ];
    case "P" :
        return [
                "P",
                false
              ];
    case "G" :
        return [
                "P",
                true
              ];
    
  }
}

function readInstrToStr(ri) {
  switch (ri) {
    case "ReadAll" :
        return "ReadAll";
    case "StopBefore" :
        return "StopBefore";
    case "StopAfter" :
        return "StopAfter";
    
  }
}

function readInstrFromStr(str) {
  switch (str) {
    case "ReadAll" :
        return "ReadAll";
    case "StopAfter" :
        return "StopAfter";
    case "StopBefore" :
        return "StopBefore";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert string '" + str + "' to a readInstr."
            },
            Error: new Error()
          };
  }
}

function mmFileSourceTypeToStr(src) {
  if (src === "Local") {
    return "Local";
  } else {
    return "Web";
  }
}

function mmFileSourceTypeFromStr(str) {
  switch (str) {
    case "Local" :
        return "Local";
    case "Web" :
        return "Web";
    default:
      throw {
            RE_EXN_ID: Common.MmException,
            _1: {
              msg: "Cannot convert string '" + str + "' to an mmFileSourceType."
            },
            Error: new Error()
          };
  }
}

function mmFileSourceTypeFromStrOpt(str) {
  switch (str) {
    case "Local" :
        return "Local";
    case "Web" :
        return "Web";
    default:
      return ;
  }
}

function createEmptyUserStmt(id, typ, label, isGoal) {
  return {
          id: id,
          label: label,
          labelEditMode: false,
          typ: typ,
          typEditMode: false,
          isGoal: isGoal,
          isBkm: false,
          cont: {
            TAG: "Text",
            text: "",
            syms: []
          },
          contEditMode: true,
          isDuplicated: false,
          jstfText: "",
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proofTreeDto: undefined,
          src: undefined,
          proof: undefined,
          proofStatus: undefined,
          unifErr: undefined,
          syntaxErr: undefined
        };
}

function userStmtToRootStmt(stmt) {
  var expr = stmt.expr;
  var tmp;
  if (expr !== undefined) {
    tmp = expr;
  } else {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "Expr must be set for a userStmt before converting to rootStmt."
          },
          Error: new Error()
        };
  }
  return {
          isHyp: stmt.typ === "E",
          label: stmt.label,
          expr: tmp,
          jstf: stmt.jstf
        };
}

function unselectStmt(stmt) {
  var treeData = stmt.cont;
  if (treeData.TAG === "Text") {
    return stmt;
  }
  var treeData$1 = treeData._0;
  var match = treeData$1.clickedNodeId;
  if (match === undefined) {
    return stmt;
  }
  var newrecord = Caml_obj.obj_dup(stmt);
  newrecord.cont = {
    TAG: "Tree",
    _0: {
      text: treeData$1.text,
      exprTyp: treeData$1.exprTyp,
      root: treeData$1.root,
      clickedNodeId: undefined,
      expLvl: treeData$1.expLvl
    }
  };
  return newrecord;
}

function editorGetStmtById(st, id) {
  return st.stmts.find(function (stmt) {
              return stmt.id === id;
            });
}

function editorGetStmtByLabel(st, label) {
  return st.stmts.find(function (stmt) {
              return stmt.label === label;
            });
}

function editorGetStmtByIdExn(st, id) {
  var stmt = editorGetStmtById(st, id);
  if (stmt !== undefined) {
    return stmt;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "editorGetStmtByIdExn: Cannot find a step by id."
        },
        Error: new Error()
      };
}

function getStmtIdx(st, id) {
  return st.stmts.findIndex(function (stmt) {
              return stmt.id === id;
            });
}

function updateStmt(st, id, update) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        if (stmt.id === id) {
          return update(stmt);
        } else {
          return stmt;
        }
      });
  return newrecord;
}

function isStmtChecked(st, stmtId) {
  return st.checkedStmtIds.some(function (param) {
              return param[0] === stmtId;
            });
}

function toggleStmtChecked(st, stmtId) {
  if (isStmtChecked(st, stmtId)) {
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (param) {
          return param[0] !== stmtId;
        });
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedStmtIds = st.checkedStmtIds.concat([[
          stmtId,
          new Date()
        ]]);
  return newrecord$1;
}

function getStmtIdsBetweenIncluding(stmtIds, stmtId1, stmtId2) {
  return Core__Array.reduce(stmtIds, [
                false,
                []
              ], (function (param, stmtId) {
                  var res = param[1];
                  var inBetween = param[0];
                  if (stmtId === stmtId1 || stmtId === stmtId2) {
                    res.push(stmtId);
                    return [
                            !inBetween,
                            res
                          ];
                  } else {
                    if (inBetween) {
                      res.push(stmtId);
                    }
                    return [
                            inBetween,
                            res
                          ];
                  }
                }))[1];
}

function toggleStmtCheckedWithShift(st, stmtId, showBkmOnly) {
  if (isStmtChecked(st, stmtId)) {
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (param) {
          return param[0] !== stmtId;
        });
    return newrecord;
  }
  var visibleStmtIds = st.stmts.filter(function (stmt) {
          if (showBkmOnly) {
            return stmt.isBkm;
          } else {
            return true;
          }
        }).map(function (stmt) {
        return stmt.id;
      });
  var lastCheckedStmtId = st.checkedStmtIds.toSorted(function (param, param$1) {
          var t1 = param[1].getTime();
          var t2 = param$1[1].getTime();
          if (t1 < t2) {
            return 1.0;
          } else if (t1 > t2) {
            return -1.0;
          } else {
            return 0.0;
          }
        }).at(0);
  var stmtIdsToCheck = lastCheckedStmtId !== undefined ? getStmtIdsBetweenIncluding(visibleStmtIds, lastCheckedStmtId[0], stmtId) : [stmtId];
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedStmtIds = st.checkedStmtIds.filter(function (param) {
        return !stmtIdsToCheck.includes(param[0]);
      });
  var newrecord$2 = Caml_obj.obj_dup(newrecord$1);
  newrecord$2.checkedStmtIds = newrecord$1.checkedStmtIds.concat(stmtIdsToCheck.map(function (id) {
            return [
                    id,
                    new Date()
                  ];
          }));
  return newrecord$2;
}

function checkAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.stmts.map(function (stmt) {
        return [
                stmt.id,
                new Date()
              ];
      });
  return newrecord;
}

function uncheckAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = st.stmts.map(unselectStmt);
  return newrecord;
}

function deleteCheckedStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return !isStmtChecked(st, stmt.id);
      });
  return newrecord;
}

function deleteStmt(st, stmtId) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (param) {
        return param[0] !== stmtId;
      });
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return stmt.id !== stmtId;
      });
  return newrecord;
}

function deleteStmts(st, stmtIds) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (param) {
        return !stmtIds.includes(param[0]);
      });
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return !stmtIds.includes(stmt.id);
      });
  return newrecord;
}

function canMoveCheckedStmts(st, up) {
  var len = st.stmts.length;
  if (len !== 0 && st.checkedStmtIds.length !== 0) {
    if (up && !isStmtChecked(st, st.stmts[0].id)) {
      return true;
    } else if (up) {
      return false;
    } else {
      return !isStmtChecked(st, st.stmts[len - 1 | 0].id);
    }
  } else {
    return false;
  }
}

function moveCheckedStmts(st, up) {
  if (!canMoveCheckedStmts(st, up)) {
    return st;
  }
  var len = st.stmts.length;
  var res = st.stmts.slice();
  if (up) {
    var maxI = len - 2 | 0;
    for(var i = 0; i <= maxI; ++i){
      if (!isStmtChecked(st, res[i].id) && isStmtChecked(st, res[i + 1 | 0].id)) {
        var tmp = res[i];
        res[i] = res[i + 1 | 0];
        res[i + 1 | 0] = tmp;
      }
      
    }
  } else {
    for(var i$1 = len - 1 | 0; i$1 >= 1; --i$1){
      if (isStmtChecked(st, res[i$1 - 1 | 0].id) && !isStmtChecked(st, res[i$1].id)) {
        var tmp$1 = res[i$1];
        res[i$1] = res[i$1 - 1 | 0];
        res[i$1 - 1 | 0] = tmp$1;
      }
      
    }
  }
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = res;
  return newrecord;
}

function moveCheckedStmtsToTop(st) {
  var checkedStmts = st.stmts.filter(function (stmt) {
        return isStmtChecked(st, stmt.id);
      });
  var uncheckedStmts = st.stmts.filter(function (stmt) {
        return !isStmtChecked(st, stmt.id);
      });
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = Belt_Array.concatMany([
        checkedStmts,
        uncheckedStmts
      ]);
  return newrecord;
}

function moveCheckedStmtsToBottom(st) {
  var checkedStmts = st.stmts.filter(function (stmt) {
        return isStmtChecked(st, stmt.id);
      });
  var uncheckedStmts = st.stmts.filter(function (stmt) {
        return !isStmtChecked(st, stmt.id);
      });
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = Belt_Array.concatMany([
        uncheckedStmts,
        checkedStmts
      ]);
  return newrecord;
}

function getRootStmtsForUnification(st) {
  var checkedStmtIds = Belt_HashSetString.fromArray(st.checkedStmtIds.map(function (param) {
            return param[0];
          }));
  if (Belt_HashSetString.size(checkedStmtIds) === 0) {
    return st.stmts;
  }
  var lowestCheckedStmtIdx;
  var i = st.stmts.length - 1 | 0;
  while(i >= 0 && Belt_Option.isNone(lowestCheckedStmtIdx)) {
    var stmt = st.stmts[i];
    if (Belt_HashSetString.has(checkedStmtIds, stmt.id)) {
      lowestCheckedStmtIdx = i;
    }
    i = i - 1 | 0;
  };
  var idx = lowestCheckedStmtIdx;
  if (idx !== undefined) {
    return st.stmts.slice(0, idx + 1 | 0);
  } else {
    return st.stmts;
  }
}

function createNewLabel(st, prefix, forHypOpt) {
  var forHyp = forHypOpt !== undefined ? forHypOpt : false;
  var reservedLabels = Belt_HashSetString.fromArray(st.stmts.map(function (stmt) {
            return stmt.label;
          }));
  var varDefs = MM_wrk_ctx_data.textToVarDefs(st.varsText);
  if (varDefs.TAG === "Ok") {
    varDefs._0.forEach(function (varDef) {
          Belt_HashSetString.add(reservedLabels, varDef[0]);
        });
  }
  var labelIsReserved = function (label) {
    if (Belt_HashSetString.has(reservedLabels, label) || MM_context.isHyp(st.preCtx, label)) {
      return true;
    } else if (forHyp) {
      return Belt_Option.isSome(MM_context.getTokenType(st.preCtx, label));
    } else {
      return false;
    }
  };
  var prefixToUse;
  if (prefix !== undefined) {
    prefixToUse = prefix;
  } else if (forHyp) {
    var goal = st.stmts.find(function (stmt) {
          return stmt.isGoal;
        });
    prefixToUse = goal !== undefined ? goal.label + "." : "";
  } else {
    prefixToUse = "";
  }
  var cnt = 1;
  var newLabel = prefixToUse + String(cnt);
  while(labelIsReserved(newLabel)) {
    cnt = cnt + 1 | 0;
    newLabel = prefixToUse + String(cnt);
  };
  return newLabel;
}

function getTopmostCheckedStmt(st) {
  if (st.checkedStmtIds.length === 0) {
    return ;
  } else {
    return st.stmts.find(function (stmt) {
                return isStmtChecked(st, stmt.id);
              });
  }
}

function getLowestCheckedStmt(st) {
  if (st.checkedStmtIds.length === 0) {
    return ;
  } else {
    return st.stmts.toReversed().find(function (stmt) {
                return isStmtChecked(st, stmt.id);
              });
  }
}

function addNewStmt(st, isHypOpt, isBkm) {
  var isHyp = isHypOpt !== undefined ? isHypOpt : false;
  var newId = String(st.nextStmtId);
  var pCnt = Core__Array.reduce(st.stmts, 0, (function (cnt, stmt) {
          if (stmt.typ === "P") {
            return cnt + 1 | 0;
          } else {
            return cnt;
          }
        }));
  var defaultStmtLabel = st.settings.defaultStmtLabel.trim();
  var newLabel = pCnt === 0 && defaultStmtLabel.length > 0 ? (
      st.stmts.some(function (stmt) {
            return stmt.label === defaultStmtLabel;
          }) ? createNewLabel(st, defaultStmtLabel, isHyp) : defaultStmtLabel
    ) : createNewLabel(st, "", isHyp);
  var isGoal = pCnt === 0 && st.settings.initStmtIsGoal;
  var idToAddBefore = Belt_Option.map(getTopmostCheckedStmt(st), (function (stmt) {
          return stmt.id;
        }));
  var newrecord = Caml_obj.obj_dup(st);
  var tmp;
  if (idToAddBefore !== undefined) {
    tmp = Belt_Array.concatMany(st.stmts.map(function (stmt) {
              if (stmt.id !== idToAddBefore) {
                return [stmt];
              }
              var newrecord = Caml_obj.obj_dup(createEmptyUserStmt(newId, "P", newLabel, isGoal));
              return [
                      (newrecord.isBkm = Belt_Option.getWithDefault(isBkm, stmt.isBkm), newrecord),
                      stmt
                    ];
            }));
  } else {
    var newrecord$1 = Caml_obj.obj_dup(createEmptyUserStmt(newId, "P", newLabel, isGoal));
    tmp = st.stmts.concat([(newrecord$1.isBkm = Belt_Option.getWithDefault(isBkm, false), newrecord$1)]);
  }
  newrecord.stmts = tmp;
  return [
          (newrecord.nextStmtId = st.nextStmtId + 1 | 0, newrecord),
          newId
        ];
}

function addNewStmtAtIdx(st, idx, isHypOpt) {
  var isHyp = isHypOpt !== undefined ? isHypOpt : false;
  var savedCheckedStmtIds = st.checkedStmtIds;
  var st$1 = uncheckAllStmts(st);
  var st$2 = 0 <= idx && idx < st$1.stmts.length ? toggleStmtChecked(st$1, st$1.stmts[idx].id) : st$1;
  var match = addNewStmt(st$2, isHyp, undefined);
  var newrecord = Caml_obj.obj_dup(match[0]);
  newrecord.checkedStmtIds = savedCheckedStmtIds;
  return [
          newrecord,
          match[1]
        ];
}

function isSingleStmtChecked(st) {
  return st.checkedStmtIds.length === 1;
}

function duplicateCheckedStmt(st, top) {
  if (!isSingleStmtChecked(st)) {
    return st;
  }
  var newId = String(st.nextStmtId);
  var match = st.checkedStmtIds[0];
  var idToAddAfter = match[0];
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [[
      newId,
      new Date()
    ]];
  newrecord.stmts = Belt_Array.concatMany(st.stmts.map(function (stmt) {
            if (stmt.id !== idToAddAfter) {
              return [stmt];
            }
            var newrecord = Caml_obj.obj_dup(stmt);
            return [
                    stmt,
                    (newrecord.jstfText = "", newrecord.isDuplicated = true, newrecord.isGoal = false, newrecord.label = createNewLabel(st, undefined, stmt.typ === "E"), newrecord.id = newId, newrecord)
                  ];
          }));
  newrecord.nextStmtId = st.nextStmtId + 1 | 0;
  if (top) {
    return moveCheckedStmts(newrecord, true);
  } else {
    return newrecord;
  }
}

function bookmarkCheckedStmts(st, isBkm) {
  var checkedStmtIds = st.checkedStmtIds.map(function (param) {
        return param[0];
      });
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        if (!checkedStmtIds.includes(stmt.id)) {
          return stmt;
        }
        var newrecord = Caml_obj.obj_dup(stmt);
        newrecord.isBkm = isBkm;
        return newrecord;
      });
  return newrecord;
}

function canGoEditModeForStmt(st, stmtId) {
  return !st.stmts.some(function (stmt) {
              if (stmt.id === stmtId) {
                if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
                  return true;
                } else {
                  return stmt.jstfEditMode;
                }
              } else {
                return false;
              }
            });
}

function setDescrEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.descrEditMode = true;
  return newrecord;
}

function setVarsEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = true;
  return newrecord;
}

function setDisjEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = true;
  return newrecord;
}

function completeDisjEditMode(st, newDisjText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = false;
  newrecord.disjText = newDisjText;
  return newrecord;
}

function setLabelEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  var newrecord = Caml_obj.obj_dup(stmt);
                  newrecord.labelEditMode = true;
                  return newrecord;
                }));
  } else {
    return st;
  }
}

function completeLabelEditMode(st, stmtId, newLabel) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newLabel.trim() === "") {
                  return stmt;
                }
                var newrecord = Caml_obj.obj_dup(stmt);
                newrecord.labelEditMode = false;
                newrecord.label = newLabel;
                return newrecord;
              }));
}

function setContEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  var newrecord = Caml_obj.obj_dup(stmt);
                  newrecord.contEditMode = true;
                  return newrecord;
                }));
  } else {
    return st;
  }
}

function completeContEditMode(st, stmtId, newContText) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newContText.trim() === "") {
                  return stmt;
                }
                var newrecord = Caml_obj.obj_dup(stmt);
                newrecord.isDuplicated = false;
                newrecord.contEditMode = false;
                newrecord.cont = strToCont(newContText, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors));
                return newrecord;
              }));
}

function setStmtCont(st, stmtId, stmtCont) {
  var newContStr = contToStr(stmtCont);
  var isDuplicated = st.settings.autoMergeStmts && st.stmts.some(function (stmt) {
        return contToStr(stmt.cont) === newContStr;
      });
  return updateStmt(st, stmtId, (function (stmt) {
                var newrecord = Caml_obj.obj_dup(stmt);
                newrecord.isDuplicated = isDuplicated;
                newrecord.cont = stmtCont;
                return newrecord;
              }));
}

function setTypEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  var newrecord = Caml_obj.obj_dup(stmt);
                  newrecord.typEditMode = true;
                  return newrecord;
                }));
  } else {
    return st;
  }
}

function setJstfEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  var newrecord = Caml_obj.obj_dup(stmt);
                  newrecord.jstfEditMode = true;
                  return newrecord;
                }));
  } else {
    return st;
  }
}

function setNextAction(st, action) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.nextAction = action;
  return newrecord;
}

function extractVarColorsFromVarsText(varsText, typeColors) {
  var res = Belt_HashMapString.make(16);
  var varDefs = MM_wrk_ctx_data.textToVarDefs(varsText);
  if (varDefs.TAG === "Ok") {
    varDefs._0.forEach(function (varDef) {
          var varName = varDef[2];
          var typ = varDef[1];
          var color = Belt_HashMapString.get(typeColors, typ);
          if (color !== undefined) {
            return Belt_HashMapString.set(res, varName, color);
          }
          
        });
  }
  return res;
}

function recalcTypeColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeColors = MM_wrk_settings.settingsGetTypeColors(st.settings);
  return newrecord;
}

function createSymbolColors(ctx, typeColors) {
  var symbolColors = Belt_HashMapString.make(100);
  MM_context.forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          if (hyp.typ === "F") {
            var typeStr = MM_context.ctxIntToSym(ctx, hyp.expr[0]);
            if (typeStr !== undefined) {
              var color = Belt_HashMapString.get(typeColors, typeStr);
              if (color !== undefined) {
                Belt_HashMapString.set(symbolColors, MM_context.ctxIntToSymExn(ctx, hyp.expr[1]), color);
              }
              
            }
            
          }
          
        }));
  return symbolColors;
}

function recalcPreCtxColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.preCtxColors = createSymbolColors(st.preCtx, st.typeColors);
  return newrecord;
}

function recalcWrkCtxColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.wrkCtxColors = extractVarColorsFromVarsText(st.varsText, st.typeColors);
  return newrecord;
}

function updateColorsInAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        var newrecord = Caml_obj.obj_dup(stmt);
        newrecord.cont = strToCont(contToStr(stmt.cont), Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors));
        return newrecord;
      });
  return newrecord;
}

function setPreCtxData(st, preCtxData) {
  var settings = preCtxData.settingsV.val;
  var preCtx = MM_context.ctxOptimizeForProver(preCtxData.ctxV.val, settings.parens, true, true);
  var parenInts = MM_wrk_ctx_data.prepareParenInts(preCtx, settings.parens);
  var numOfParens = parenInts.length / 2 | 0;
  var parensMap = Belt_HashMapString.make(numOfParens);
  for(var i = 0; i < numOfParens; ++i){
    Belt_HashMapString.set(parensMap, MM_context.ctxIntToSymExn(preCtx, parenInts[(i << 1)]), MM_context.ctxIntToSymExn(preCtx, parenInts[(i << 1) + 1 | 0]));
  }
  var typeOrderInDisj = Common.createTypeOrderFromStr(settings.sortDisjByType, (function (__x) {
          return MM_context.ctxSymToInt(preCtx, __x);
        }));
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeOrderInDisj = typeOrderInDisj;
  newrecord.parensMap = parensMap;
  newrecord.syntaxTypes = preCtxData.syntaxTypes;
  newrecord.allTypes = preCtxData.allTypes;
  newrecord.parenCnt = preCtxData.parenCnt;
  newrecord.frms = preCtxData.frms;
  newrecord.preCtx = preCtx;
  newrecord.preCtxV = preCtxData.ctxV.ver;
  newrecord.srcs = preCtxData.srcs;
  newrecord.settings = settings;
  newrecord.settingsV = preCtxData.settingsV.ver;
  var st$1 = recalcTypeColors(newrecord);
  var st$2 = recalcPreCtxColors(st$1);
  var st$3 = recalcWrkCtxColors(st$2);
  return updateColorsInAllStmts(st$3);
}

function completeDescrEditMode(st, newDescr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.descrEditMode = false;
  newrecord.descr = newDescr;
  return newrecord;
}

function recalcWrkColors(st) {
  var st$1 = recalcWrkCtxColors(st);
  return updateColorsInAllStmts(st$1);
}

function completeVarsEditMode(st, newVarsText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = false;
  newrecord.varsText = newVarsText;
  return recalcWrkColors(newrecord);
}

function sortStmtsByType(st) {
  var stmtToInt = function (stmt) {
    var match = stmt.typ;
    if (match === "E") {
      return 1;
    } else if (st.settings.stickGoalToBottom && stmt.isGoal) {
      return 3;
    } else {
      return 2;
    }
  };
  var comp = function (a, b) {
    return stmtToInt(a) - stmtToInt(b) | 0;
  };
  var stmtsLen = st.stmts.length;
  if (stmtsLen < 2) {
    return st;
  }
  var newStmts = st.stmts.slice();
  var changed = true;
  var e = stmtsLen - 2 | 0;
  while(e >= 0 && changed) {
    changed = false;
    for(var i = 0; i <= e; ++i){
      if (comp(newStmts[i], newStmts[i + 1 | 0]) > 0) {
        var tmp = newStmts[i];
        newStmts[i] = newStmts[i + 1 | 0];
        newStmts[i + 1 | 0] = tmp;
        changed = true;
      }
      
    }
    e = e - 1 | 0;
  };
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = newStmts;
  return newrecord;
}

function removeAllTempData(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        var newrecord = Caml_obj.obj_dup(stmt);
        newrecord.syntaxErr = undefined;
        newrecord.unifErr = undefined;
        newrecord.proofStatus = undefined;
        newrecord.proof = undefined;
        newrecord.src = undefined;
        newrecord.proofTreeDto = undefined;
        newrecord.jstf = undefined;
        newrecord.expr = undefined;
        newrecord.stmtErr = undefined;
        return newrecord;
      });
  newrecord.disjErr = undefined;
  newrecord.varsErr = undefined;
  return newrecord;
}

function isEditMode(st) {
  if (st.descrEditMode || st.varsEditMode || st.disjEditMode) {
    return true;
  } else {
    return st.stmts.some(function (stmt) {
                if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
                  return true;
                } else {
                  return stmt.jstfEditMode;
                }
              });
  }
}

function userStmtHasCriticalErrors(stmt) {
  return Belt_Option.isSome(stmt.stmtErr);
}

function userStmtHasAnyErrors(stmt) {
  if (Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr)) {
    return true;
  } else {
    return Belt_Option.isSome(stmt.unifErr);
  }
}

function editorStateHasCriticalErrors(st) {
  if (Belt_Option.isSome(st.varsErr) || Belt_Option.isSome(st.disjErr)) {
    return true;
  } else {
    return st.stmts.some(userStmtHasCriticalErrors);
  }
}

function editorStateGetTextDescriptionOfAllCriticalErrors(st) {
  var res = [];
  Core__Option.forEach(st.varsErr, (function (msg) {
          res.push("Variable definition error: " + msg);
        }));
  Core__Option.forEach(st.disjErr, (function (msg) {
          res.push("Disjoints error: " + msg);
        }));
  if (st.stmts.some(userStmtHasCriticalErrors)) {
    res.push("Errors for steps:");
    st.stmts.forEach(function (stmt) {
          Core__Option.forEach(stmt.stmtErr, (function (err) {
                  res.push(contToStr(stmt.cont) + ":");
                  res.push(err.msg);
                }));
        });
  }
  return res.join(" \n");
}

function editorStateHasAnyErrors(st) {
  if (editorStateHasCriticalErrors(st)) {
    return true;
  } else {
    return st.stmts.some(userStmtHasAnyErrors);
  }
}

function editorStateHasDuplicatedStmts(st) {
  return st.stmts.some(function (stmt) {
              return Belt_Option.getWithDefault(Belt_Option.map(stmt.stmtErr, (function (err) {
                                return err.code === 1;
                              })), false);
            });
}

function refreshWrkCtx(st) {
  var wrkCtxRes = MM_wrk_ctx_data.createWrkCtx(st.preCtx, st.varsText, st.disjText);
  if (wrkCtxRes.TAG !== "Ok") {
    var wrkCtxErr = wrkCtxRes._0;
    var msg = wrkCtxErr.varsErr;
    var st$1;
    if (msg !== undefined) {
      var newrecord = Caml_obj.obj_dup(st);
      newrecord.varsErr = msg;
      st$1 = newrecord;
    } else {
      st$1 = st;
    }
    var msg$1 = wrkCtxErr.disjErr;
    if (msg$1 === undefined) {
      return st$1;
    }
    var newrecord$1 = Caml_obj.obj_dup(st$1);
    newrecord$1.disjErr = msg$1;
    return newrecord$1;
  }
  var newrecord$2 = Caml_obj.obj_dup(st);
  newrecord$2.wrkCtx = Caml_option.some(wrkCtxRes._0);
  return newrecord$2;
}

function parseJstf(jstfText) {
  var jstfText$1 = jstfText.trim();
  if (jstfText$1.length === 0) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var argsAndAsrt = jstfText$1.split(":");
  if (argsAndAsrt.length !== 2) {
    return {
            TAG: "Error",
            _0: "Cannot parse justification: '" + jstfText$1 + "'. A justification must contain exactly one colon symbol."
          };
  } else if (argsAndAsrt[1].trim() === "") {
    return {
            TAG: "Error",
            _0: "Cannot parse justification: '" + jstfText$1 + "'. Reference must not be empty."
          };
  } else {
    return {
            TAG: "Ok",
            _0: {
              args: Common.getSpaceSeparatedValuesAsArray(argsAndAsrt[0]),
              label: argsAndAsrt[1].trim()
            }
          };
  }
}

function setStmtJstf(stmt) {
  if (Belt_Option.isSome(stmt.stmtErr) || stmt.typ === "E") {
    return stmt;
  }
  var msg = parseJstf(stmt.jstfText);
  if (msg.TAG === "Ok") {
    var newrecord = Caml_obj.obj_dup(stmt);
    newrecord.jstf = msg._0;
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(stmt);
  newrecord$1.stmtErr = {
    code: -1,
    msg: msg._0
  };
  return newrecord$1;
}

function isLabelDefined(label, wrkCtx, definedUserLabels) {
  if (Belt_HashSetString.has(definedUserLabels, label)) {
    return true;
  } else {
    return MM_context.isHyp(wrkCtx, label);
  }
}

function prepareUserStmtsForUnification(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var stmtsLen = st.stmts.length;
    var definedUserLabels = Belt_HashSetString.make(stmtsLen);
    var definedUserExprs = Belt_HashMap.make(stmtsLen, MM_context.ExprHash);
    var goalLabel = {
      contents: undefined
    };
    var actions = [
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          if (__x.typ === "E" || __x.typ === "P" && __x.isGoal) {
            var tokenType = MM_context.getTokenType(wrkCtx$1, __x.label);
            if (tokenType !== undefined) {
              if (__x.typ === "E") {
                var newrecord = Caml_obj.obj_dup(__x);
                newrecord.stmtErr = {
                  code: -1,
                  msg: "[1] Cannot reuse label '" + __x.label + "'."
                };
                return newrecord;
              }
              switch (tokenType) {
                case "A" :
                case "P" :
                    return __x;
                default:
                  var newrecord$1 = Caml_obj.obj_dup(__x);
                  newrecord$1.stmtErr = {
                    code: -1,
                    msg: "[2] Cannot reuse label '" + __x.label + "'."
                  };
                  return newrecord$1;
              }
            } else {
              if (!isLabelDefined(__x.label, wrkCtx$1, definedUserLabels)) {
                return __x;
              }
              var newrecord$2 = Caml_obj.obj_dup(__x);
              newrecord$2.stmtErr = {
                code: -1,
                msg: "[3] Cannot reuse label '" + __x.label + "'."
              };
              return newrecord$2;
            }
          } else {
            if (!isLabelDefined(__x.label, wrkCtx$1, definedUserLabels)) {
              return __x;
            }
            var newrecord$3 = Caml_obj.obj_dup(__x);
            newrecord$3.stmtErr = {
              code: -1,
              msg: "[4] Cannot reuse label '" + __x.label + "'."
            };
            return newrecord$3;
          }
        }),
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          try {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.expr = MM_context.ctxSymsToIntsExn(wrkCtx$1, contToArrStr(__x.cont));
            return newrecord;
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === Common.MmException) {
              var newrecord$1 = Caml_obj.obj_dup(__x);
              newrecord$1.stmtErr = {
                code: -1,
                msg: exn._1.msg
              };
              return newrecord$1;
            }
            throw exn;
          }
        }),
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          var goalLabel$1 = goalLabel.contents;
          if (goalLabel$1 === undefined) {
            return __x;
          }
          if (!__x.isGoal) {
            return __x;
          }
          var newrecord = Caml_obj.obj_dup(__x);
          newrecord.stmtErr = {
            code: -1,
            msg: "Cannot re-define the goal. Previously defined goal is the step labeled" + (" '" + goalLabel$1 + "'")
          };
          return newrecord;
        }),
      setStmtJstf,
      (function (__x) {
          var frms = st.frms;
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          var match = __x.jstf;
          if (match === undefined) {
            return __x;
          }
          var label = match.label;
          var args = match.args;
          var jstfArgLabel = args.find(function (ref) {
                return !isLabelDefined(ref, wrkCtx$1, definedUserLabels);
              });
          if (jstfArgLabel !== undefined) {
            var newrecord = Caml_obj.obj_dup(__x);
            newrecord.stmtErr = {
              code: -1,
              msg: "The label '" + jstfArgLabel + "' is not defined."
            };
            return newrecord;
          }
          if (MM_context.isAsrt(wrkCtx$1, label)) {
            var frm = MM_substitution.frmsGetByLabel(frms, label);
            if (frm !== undefined) {
              var expectedNumberOfArgs = frm.numOfHypsE;
              var providedNumberOfArgs = args.length;
              if (providedNumberOfArgs === expectedNumberOfArgs) {
                return __x;
              }
              var eHypsText = expectedNumberOfArgs === 1 ? "essential hypothesis" : "essential hypotheses";
              var isAreText = providedNumberOfArgs === 1 ? "is" : "are";
              var newrecord$1 = Caml_obj.obj_dup(__x);
              newrecord$1.stmtErr = {
                code: -1,
                msg: "'" + label + "' assertion expects " + String(expectedNumberOfArgs) + " " + eHypsText + " but" + (" " + String(providedNumberOfArgs) + " " + isAreText + " provided.")
              };
              return newrecord$1;
            }
            throw {
                  RE_EXN_ID: Common.MmException,
                  _1: {
                    msg: "Could not get frame by label '" + label + "'"
                  },
                  Error: new Error()
                };
          }
          var newrecord$2 = Caml_obj.obj_dup(__x);
          newrecord$2.stmtErr = {
            code: -1,
            msg: "The label '" + label + "' doesn't refer to any assertion."
          };
          return newrecord$2;
        }),
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          var expr = __x.expr;
          if (expr !== undefined) {
            var hyp = MM_context.getHypByExpr(wrkCtx$1, expr);
            if (hyp !== undefined) {
              var newrecord = Caml_obj.obj_dup(__x);
              newrecord.stmtErr = {
                code: 1,
                msg: "This statement is the same as the previously defined" + (" hypothesis - '" + hyp.label + "'")
              };
              return newrecord;
            }
            var prevStmtLabel = Belt_HashMap.get(definedUserExprs, expr);
            if (prevStmtLabel !== undefined) {
              var newrecord$1 = Caml_obj.obj_dup(__x);
              newrecord$1.stmtErr = {
                code: 1,
                msg: "This statement is the same as the previous" + (" one - '" + prevStmtLabel + "'")
              };
              return newrecord$1;
            }
            if (!(!__x.contEditMode && (expr.length === 0 || expr[0] >= 0))) {
              return __x;
            }
            var newrecord$2 = Caml_obj.obj_dup(__x);
            newrecord$2.stmtErr = {
              code: -1,
              msg: "Any statement must begin with a constant."
            };
            return newrecord$2;
          }
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Cannot validateStmtExpr without expr."
                },
                Error: new Error()
              };
        })
    ];
    return Core__Array.reduce(st.stmts, st, (function (st, stmt) {
                  if (editorStateHasCriticalErrors(st)) {
                    return st;
                  }
                  var stmt$1 = Core__Array.reduce(actions, stmt, (function (stmt, action) {
                          if (Belt_Option.isSome(stmt.stmtErr)) {
                            return stmt;
                          } else {
                            return action(stmt);
                          }
                        }));
                  Belt_HashSetString.add(definedUserLabels, stmt$1.label);
                  if (!Belt_Option.isSome(stmt$1.stmtErr)) {
                    var expr = stmt$1.expr;
                    if (expr !== undefined) {
                      Belt_HashMap.set(definedUserExprs, expr, stmt$1.label);
                    } else {
                      throw {
                            RE_EXN_ID: Common.MmException,
                            _1: {
                              msg: "Expr must be set in prepareUserStmtsForUnification."
                            },
                            Error: new Error()
                          };
                    }
                    if (stmt$1.isGoal) {
                      goalLabel.contents = stmt$1.label;
                    }
                    
                  }
                  return updateStmt(st, stmt$1.id, (function (param) {
                                return stmt$1;
                              }));
                }));
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot prepareUserStmtsForUnification without wrkCtx."
        },
        Error: new Error()
      };
}

function prepareEditorForUnification(st) {
  var st$1 = removeAllTempData(st);
  return Core__Array.reduce([
              sortStmtsByType,
              refreshWrkCtx,
              prepareUserStmtsForUnification
            ], st$1, (function (st, act) {
                if (editorStateHasCriticalErrors(st)) {
                  return st;
                } else {
                  return act(st);
                }
              }));
}

function getTheOnlyCheckedStmt(st) {
  if (st.checkedStmtIds.length !== 1) {
    return ;
  } else {
    return getTopmostCheckedStmt(st);
  }
}

function createNewVars(st, varTypes, varNames, dontAddVariablesToContextOpt) {
  var dontAddVariablesToContext = dontAddVariablesToContextOpt !== undefined ? dontAddVariablesToContextOpt : false;
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var numOfVars = varTypes.length;
    if (numOfVars === 0) {
      return [
              st,
              []
            ];
    }
    var newVarNames;
    if (varNames !== undefined) {
      if (varTypes.length !== varNames.length) {
        throw {
              RE_EXN_ID: Common.MmException,
              _1: {
                msg: "varTypes->Array.length != varNames->Array.length"
              },
              Error: new Error()
            };
      }
      newVarNames = varNames;
    } else {
      var typeToPrefix = Belt_MapString.fromArray(st.settings.typeSettings.map(function (ts) {
                return [
                        ts.typ,
                        ts.prefix
                      ];
              }));
      newVarNames = MM_context.generateNewVarNames(wrkCtx$1, varTypes, Caml_option.some(typeToPrefix), undefined);
    }
    var newHypLabels = MM_context.generateNewLabels(wrkCtx$1, "var", numOfVars, undefined, undefined);
    var varTypeNames = MM_context.ctxIntsToSymsExn(wrkCtx$1, varTypes);
    if (!dontAddVariablesToContext) {
      MM_context.applySingleStmt(wrkCtx$1, {
            TAG: "Var",
            symbols: newVarNames
          }, undefined, undefined, undefined, undefined);
      newHypLabels.forEach(function (label, i) {
            MM_context.applySingleStmt(wrkCtx$1, {
                  TAG: "Floating",
                  label: label,
                  expr: [
                    varTypeNames[i],
                    newVarNames[i]
                  ]
                }, undefined, undefined, undefined, undefined);
          });
    }
    var newVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, newVarNames);
    var newVarsText = newHypLabels.map(function (label, i) {
            return label + " " + varTypeNames[i] + " " + newVarNames[i];
          }).join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.varsText = [
          st.varsText,
          newVarsText
        ].join("\n").trim();
    var st$1 = recalcWrkCtxColors(newrecord);
    return [
            st$1,
            newVarInts
          ];
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot create new variables without wrkCtx."
        },
        Error: new Error()
      };
}

function createNewDisj(st, newDisj) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var newDisjTextLines = [];
    MM_context.disjForEachArr(newDisj, undefined, undefined, undefined, undefined, (function (varInts) {
            var varsStr = MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts);
            MM_context.applySingleStmt(wrkCtx$1, {
                  TAG: "Disj",
                  vars: varsStr
                }, undefined, undefined, undefined, undefined);
            newDisjTextLines.push(varsStr.join(" "));
          }));
    if (newDisjTextLines.length === 0) {
      return st;
    }
    var newDisjText = newDisjTextLines.join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.disjText = [
          st.disjText,
          newDisjText
        ].join("\n").trim();
    return newrecord;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot create new disjoints without wrkCtx."
        },
        Error: new Error()
      };
}

function stmtsHaveSameExpr(stmt, stmtDto) {
  var expr = stmt.expr;
  if (expr !== undefined) {
    return MM_context.exprEq(expr, stmtDto.expr);
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot compare steps without expr."
        },
        Error: new Error()
      };
}

function getUserStmtByExpr(st, expr) {
  return st.stmts.find(function (stmt) {
              var stmtExpr = stmt.expr;
              if (stmtExpr !== undefined) {
                return MM_context.exprEq(stmtExpr, expr);
              }
              throw {
                    RE_EXN_ID: Common.MmException,
                    _1: {
                      msg: "Cannot getUserStmtByExpr without stmt.expr."
                    },
                    Error: new Error()
                  };
            });
}

function insertStmt(st, expr, jstf, before, placeAtMaxIdxByDefault, isBkm) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var hyp = MM_context.getHypByExpr(wrkCtx$1, expr);
    if (hyp !== undefined) {
      return [
              st,
              hyp.label
            ];
    }
    var maxIdx;
    if (before !== undefined) {
      var idx = st.stmts.findIndex(function (stmt) {
            return stmt.id === before;
          });
      maxIdx = idx !== -1 ? idx : st.stmts.length;
    } else {
      maxIdx = st.stmts.length;
    }
    var minIdx;
    if (jstf !== undefined) {
      var remainingLabels = Belt_HashSetString.fromArray(jstf.args);
      var minIdx$1 = Core__Array.reduceWithIndex(st.stmts, 0, (function (minIdx, stmt, idx) {
              if (Belt_HashSetString.isEmpty(remainingLabels)) {
                return minIdx;
              } else {
                Belt_HashSetString.remove(remainingLabels, stmt.label);
                return idx + 1 | 0;
              }
            }));
      minIdx = maxIdx < minIdx$1 ? maxIdx : minIdx$1;
    } else {
      minIdx = 0;
    }
    var insertNewStmt = function (st, existingStmt) {
      var newIdx;
      if (existingStmt !== undefined) {
        var newIdx$1 = getStmtIdx(st, existingStmt.id) + 1 | 0;
        newIdx = minIdx <= newIdx$1 && newIdx$1 <= maxIdx ? newIdx$1 : minIdx;
      } else {
        newIdx = placeAtMaxIdxByDefault ? maxIdx : minIdx;
      }
      var match = addNewStmtAtIdx(st, newIdx, undefined);
      var newStmtId = match[1];
      var st$1 = match[0];
      var st$2 = updateStmt(st$1, newStmtId, (function (stmt) {
              var newrecord = Caml_obj.obj_dup(stmt);
              newrecord.expr = expr;
              newrecord.jstfText = Belt_Option.mapWithDefault(jstf, "", MM_statements_dto.jstfToStr);
              newrecord.contEditMode = false;
              newrecord.cont = strToCont(MM_context.ctxIntsToStrExn(wrkCtx$1, expr), Caml_option.some(st$1.preCtxColors), Caml_option.some(st$1.wrkCtxColors));
              newrecord.isBkm = isBkm;
              newrecord.typ = "P";
              return newrecord;
            }));
      return [
              st$2,
              editorGetStmtByIdExn(st$2, newStmtId).label
            ];
    };
    var existingJstfEqNewJstf = function (existingJstf) {
      if (jstf !== undefined) {
        return MM_statements_dto.jstfEq(existingJstf, jstf);
      } else {
        return false;
      }
    };
    var existingStmt = getUserStmtByExpr(st, expr);
    if (existingStmt === undefined) {
      return insertNewStmt(st, undefined);
    }
    if (existingStmt.typ === "E" || Belt_Option.isNone(jstf)) {
      return [
              st,
              existingStmt.label
            ];
    }
    var match = parseJstf(existingStmt.jstfText);
    if (match.TAG !== "Ok") {
      return insertNewStmt(st, existingStmt);
    }
    var existingJstf = match._0;
    if (existingJstf !== undefined) {
      if (existingJstfEqNewJstf(existingJstf)) {
        return [
                st,
                existingStmt.label
              ];
      } else {
        return insertNewStmt(st, existingStmt);
      }
    } else {
      var st$1 = jstf !== undefined ? updateStmt(st, existingStmt.id, (function (stmt) {
                var newrecord = Caml_obj.obj_dup(stmt);
                newrecord.jstfText = MM_statements_dto.jstfToStr(jstf);
                return newrecord;
              })) : st;
      return [
              st$1,
              existingStmt.label
            ];
    }
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot insertStmt without wrkCtx."
        },
        Error: new Error()
      };
}

function replaceDtoVarsWithCtxVarsInExprs(newStmts, newStmtsVarToCtxVar) {
  return {
          newVars: newStmts.newVars,
          newVarTypes: newStmts.newVarTypes,
          newDisj: newStmts.newDisj,
          newDisjStr: newStmts.newDisjStr,
          stmts: newStmts.stmts.map(function (stmt) {
                return {
                        label: stmt.label,
                        expr: stmt.expr.map(function (i) {
                              return Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, i, i);
                            }),
                        exprStr: stmt.exprStr,
                        jstf: stmt.jstf,
                        isProved: stmt.isProved
                      };
              })
        };
}

function addNewStatements(st, newStmts, isBkmOpt) {
  var isBkm = isBkmOpt !== undefined ? isBkmOpt : false;
  var match = createNewVars(st, newStmts.newVarTypes, undefined, undefined);
  var newCtxVarInts = match[1];
  var newStmtsVarToCtxVar = Belt_MutableMapInt.make();
  newStmts.newVars.forEach(function (newStmtsVarInt, i) {
        Belt_MutableMapInt.set(newStmtsVarToCtxVar, newStmtsVarInt, newCtxVarInts[i]);
      });
  var newStmts$1 = replaceDtoVarsWithCtxVarsInExprs(newStmts, newStmtsVarToCtxVar);
  var newCtxDisj = MM_context.disjMake();
  MM_context.disjForEach(newStmts$1.newDisj, (function (n, m) {
          MM_context.disjAddPair(newCtxDisj, Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, n, n), Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, m, m));
        }));
  var st$1 = createNewDisj(match[0], newCtxDisj);
  var checkedStmt = getLowestCheckedStmt(st$1);
  var newStmtsLabelToCtxLabel = Belt_MutableMapString.make();
  var replaceDtoLabelsWithCtxLabels = function (jstf) {
    return {
            args: jstf.args.map(function (arg) {
                  return Belt_MutableMapString.getWithDefault(newStmtsLabelToCtxLabel, arg, arg);
                }),
            label: jstf.label
          };
  };
  var mergeWillBeNeeded = newStmts$1.stmts.some(function (stmtDto) {
        return st$1.stmts.some(function (userStmt) {
                    return stmtsHaveSameExpr(userStmt, stmtDto);
                  });
      });
  var placeAtMaxIdxByDefault = Belt_Option.isSome(checkedStmt) && !mergeWillBeNeeded;
  var stMut = {
    contents: st$1
  };
  newStmts$1.stmts.forEach(function (stmtDto) {
        if (Belt_Option.isSome(checkedStmt) && stmtsHaveSameExpr(Belt_Option.getExn(checkedStmt), stmtDto)) {
          var checkedStmt$1 = Belt_Option.getExn(checkedStmt);
          stMut.contents = updateStmt(stMut.contents, checkedStmt$1.id, (function (stmtToUpdate) {
                  var newrecord = Caml_obj.obj_dup(stmtToUpdate);
                  var jstf = stmtDto.jstf;
                  newrecord.jstfText = jstf !== undefined ? MM_statements_dto.jstfToStr(replaceDtoLabelsWithCtxLabels(jstf)) : stmtToUpdate.jstfText;
                  return newrecord;
                }));
          return Belt_MutableMapString.set(newStmtsLabelToCtxLabel, stmtDto.label, checkedStmt$1.label);
        }
        var match = insertStmt(stMut.contents, stmtDto.expr, Belt_Option.map(stmtDto.jstf, replaceDtoLabelsWithCtxLabels), Belt_Option.map(checkedStmt, (function (stmt) {
                    return stmt.id;
                  })), placeAtMaxIdxByDefault, isBkm);
        stMut.contents = match[0];
        Belt_MutableMapString.set(newStmtsLabelToCtxLabel, stmtDto.label, match[1]);
      });
  return stMut.contents;
}

function removeUnusedVars(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedSymbols = Belt_HashSetString.fromArray(Expln_utils_common.arrFlatMap(st.stmts, (function (stmt) {
                return contToArrStr(stmt.cont);
              })));
    MM_context.getLocalHyps(wrkCtx$1).forEach(function (hyp) {
          if (hyp.typ === "F" && hyp.label.startsWith(".")) {
            return Belt_HashSetString.add(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, hyp.expr[1]));
          }
          
        });
    var unusedVars = MM_context.getLocalVars(wrkCtx$1).filter(function ($$var) {
          return !Belt_HashSetString.has(usedSymbols, $$var);
        });
    var st$1;
    if (unusedVars.length === 0) {
      st$1 = st;
    } else {
      var unusedVarInts = Belt_HashSetInt.fromArray(MM_context.ctxSymsToIntsExn(wrkCtx$1, unusedVars));
      var usedLocalVarsStr = MM_context.getLocalHyps(wrkCtx$1).filter(function (hyp) {
                if (hyp.typ === "F") {
                  return !Belt_HashSetInt.has(unusedVarInts, hyp.expr[1]);
                } else {
                  return false;
                }
              }).map(function (hyp) {
              return hyp.label + " " + MM_context.ctxIntToSymExn(wrkCtx$1, hyp.expr[0]) + " " + MM_context.ctxIntToSymExn(wrkCtx$1, hyp.expr[1]);
            }).join("\n");
      st$1 = completeVarsEditMode(st, usedLocalVarsStr);
    }
    var newDisj = MM_context.disjMake();
    MM_context.disjForEach(MM_context.getLocalDisj(wrkCtx$1), (function (n, m) {
            if (Belt_HashSetString.has(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, n)) && Belt_HashSetString.has(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, m))) {
              return MM_context.disjAddPair(newDisj, n, m);
            }
            
          }));
    var newDisjText = MM_context.disjToArr(newDisj, true, (function (__x) {
                return MM_context.ctxIntToSym(wrkCtx$1, __x);
              }), (function (__x) {
                return MM_context.getTypeOfVar(wrkCtx$1, __x);
              }), Caml_option.some(st$1.typeOrderInDisj)).map(function (dgrp) {
            return MM_context.ctxIntsToSymsExn(wrkCtx$1, dgrp).join(" ");
          }).join("\n");
    if (st$1.disjText !== newDisjText) {
      return completeDisjEditMode(st$1, newDisjText);
    } else {
      return st$1;
    }
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot remove unused variables without wrkCtx."
        },
        Error: new Error()
      };
}

function srcToJstf(wrkCtx, proofTree, exprSrc, exprToUserStmt) {
  if (typeof exprSrc !== "object") {
    return ;
  }
  if (exprSrc.TAG !== "Assertion") {
    return ;
  }
  var label = exprSrc.label;
  var args = exprSrc.args;
  var frame = MM_context.getFrame(wrkCtx, label);
  if (frame !== undefined) {
    var argLabels = [];
    var argLabelsValid = {
      contents: true
    };
    frame.hyps.forEach(function (hyp, i) {
          if (!(hyp.typ === "E" && argLabelsValid.contents)) {
            return ;
          }
          var nodeIdx = Belt_Array.get(args, i);
          if (nodeIdx !== undefined) {
            var userStmt = Belt_HashMap.get(exprToUserStmt, proofTree.nodes[nodeIdx].expr);
            if (userStmt !== undefined) {
              argLabels.push(userStmt.label);
            } else {
              argLabelsValid.contents = false;
            }
            return ;
          }
          throw {
                RE_EXN_ID: Common.MmException,
                _1: {
                  msg: "Too few arguments for '" + label + "' in srcToJstf."
                },
                Error: new Error()
              };
        });
    if (argLabelsValid.contents) {
      return {
              args: argLabels,
              label: label
            };
    } else {
      return ;
    }
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot find an assertion '" + label + "' in srcToJstf."
        },
        Error: new Error()
      };
}

function userStmtSetJstfTextAndProof(stmt, wrkCtx, proofTree, proofNode, exprToUserStmt) {
  var proofSrc = proofNode.proof;
  var stmt$1;
  if (proofSrc !== undefined) {
    var jstfFromProof = srcToJstf(wrkCtx, proofTree, proofSrc, exprToUserStmt);
    if (jstfFromProof !== undefined) {
      var existingJstf = stmt.jstf;
      if (existingJstf !== undefined) {
        if (MM_statements_dto.jstfEq(jstfFromProof, existingJstf)) {
          var newrecord = Caml_obj.obj_dup(stmt);
          newrecord.proof = proofNode;
          newrecord.proofTreeDto = proofTree;
          stmt$1 = newrecord;
        } else {
          stmt$1 = stmt;
        }
      } else {
        var newrecord$1 = Caml_obj.obj_dup(stmt);
        newrecord$1.proof = proofNode;
        newrecord$1.proofTreeDto = proofTree;
        newrecord$1.jstfText = MM_statements_dto.jstfToStr(jstfFromProof);
        stmt$1 = newrecord$1;
      }
    } else {
      stmt$1 = stmt;
    }
  } else {
    stmt$1 = stmt;
  }
  var newrecord$2 = Caml_obj.obj_dup(stmt$1);
  newrecord$2.proofTreeDto = proofTree;
  return newrecord$2;
}

function getColorForSymbol(sym, preCtxColors, wrkCtxColors) {
  if (preCtxColors === undefined) {
    return Belt_Option.flatMap(wrkCtxColors, (function (wrkCtxColors) {
                  return Belt_HashMapString.get(wrkCtxColors, sym);
                }));
  }
  var color = Belt_HashMapString.get(Caml_option.valFromOption(preCtxColors), sym);
  if (color !== undefined) {
    return color;
  } else {
    return Belt_Option.flatMap(wrkCtxColors, (function (wrkCtxColors) {
                  return Belt_HashMapString.get(wrkCtxColors, sym);
                }));
  }
}

function addColorsToSyntaxTree(tree, preCtxColors, wrkCtxColors) {
  return {
          id: tree.id,
          parent: tree.parent,
          typ: tree.typ,
          label: tree.label,
          children: tree.children.map(function (child) {
                if (child.TAG === "Subtree") {
                  return {
                          TAG: "Subtree",
                          _0: addColorsToSyntaxTree(child._0, preCtxColors, wrkCtxColors)
                        };
                } else {
                  return {
                          TAG: "Symbol",
                          id: child.id,
                          parent: child.parent,
                          symInt: child.symInt,
                          sym: child.sym,
                          color: getColorForSymbol(child.sym, preCtxColors, wrkCtxColors),
                          isVar: child.isVar
                        };
                }
              }),
          height: tree.height
        };
}

function checkParensMatch(expr, parenCnt) {
  var parenState = "Balanced";
  MM_parenCounter.parenCntReset(parenCnt);
  var i = 0;
  while(i < expr.length && parenState !== "Failed") {
    parenState = MM_parenCounter.parenCntPut(parenCnt, expr[i]);
    i = i + 1 | 0;
  };
  return parenState === "Balanced";
}

function stmtSetSyntaxTree(st, stmt, expr, wrkCtx, syntaxNodes, proofTreeDto) {
  var match = stmt.cont;
  if (match.TAG !== "Text") {
    return stmt;
  }
  var nodeDto = Belt_HashMap.get(syntaxNodes, expr.slice(1));
  var syntaxTree = nodeDto !== undefined ? MM_syntax_tree.buildSyntaxTreeFromProofTreeDto(wrkCtx, proofTreeDto, nodeDto.expr) : undefined;
  if (syntaxTree !== undefined) {
    if (syntaxTree.TAG === "Ok") {
      var newrecord = Caml_obj.obj_dup(stmt);
      newrecord.cont = {
        TAG: "Tree",
        _0: {
          text: match.text,
          exprTyp: match.syms[0].sym,
          root: addColorsToSyntaxTree(syntaxTree._0, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors)),
          clickedNodeId: undefined,
          expLvl: 0
        }
      };
      return newrecord;
    }
    var newrecord$1 = Caml_obj.obj_dup(stmt);
    newrecord$1.syntaxErr = syntaxTree._0;
    return newrecord$1;
  }
  if (!st.settings.checkSyntax) {
    return stmt;
  }
  var newrecord$2 = Caml_obj.obj_dup(stmt);
  newrecord$2.syntaxErr = checkParensMatch(expr, st.parenCnt) ? "" : "parentheses mismatch";
  return newrecord$2;
}

function applyUnifyAllResults(st, proofTreeDto) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var exprToNode = Belt_HashMap.fromArray(proofTreeDto.nodes.map(function (node) {
              return [
                      node.expr,
                      node
                    ];
            }), MM_context.ExprHash);
    var exprToUserStmt = Belt_HashMap.fromArray(st.stmts.map(function (stmt) {
              var expr = stmt.expr;
              if (expr !== undefined) {
                return [
                        expr,
                        stmt
                      ];
              }
              throw {
                    RE_EXN_ID: Common.MmException,
                    _1: {
                      msg: "Cannot applyUnifyAllResults without stmt.expr [1]."
                    },
                    Error: new Error()
                  };
            }), MM_context.ExprHash);
    var syntaxNodes = Belt_HashMap.fromArray(proofTreeDto.syntaxProofs, MM_context.ExprHash);
    return Core__Array.reduce(st.stmts, st, (function (st, stmt) {
                  var newrecord = Caml_obj.obj_dup(stmt);
                  newrecord.proofStatus = undefined;
                  newrecord.proof = undefined;
                  return updateStmt(st, newrecord.id, (function (stmt) {
                                var expr = stmt.expr;
                                if (expr !== undefined) {
                                  var stmt$1 = stmtSetSyntaxTree(st, stmt, expr, wrkCtx$1, syntaxNodes, proofTreeDto);
                                  if (stmt$1.typ !== "P") {
                                    return stmt$1;
                                  }
                                  var node = Belt_HashMap.get(exprToNode, expr);
                                  if (node !== undefined) {
                                    var stmt$2 = userStmtSetJstfTextAndProof(stmt$1, wrkCtx$1, proofTreeDto, node, exprToUserStmt);
                                    var proofNode = stmt$2.proof;
                                    if (proofNode !== undefined) {
                                      var newrecord = Caml_obj.obj_dup(stmt$2);
                                      newrecord.proofStatus = "Ready";
                                      newrecord.src = proofNode.proof;
                                      return newrecord;
                                    }
                                    var jstf = stmt$2.jstf;
                                    if (jstf !== undefined) {
                                      var src = node.parents.find(function (__x) {
                                            var jstfFromSrc = srcToJstf(wrkCtx$1, proofTreeDto, __x, exprToUserStmt);
                                            if (jstfFromSrc !== undefined) {
                                              return MM_statements_dto.jstfEq(jstf, jstfFromSrc);
                                            } else {
                                              return false;
                                            }
                                          });
                                      if (src !== undefined) {
                                        var newrecord$1 = Caml_obj.obj_dup(stmt$2);
                                        newrecord$1.proofStatus = "Waiting";
                                        newrecord$1.src = src;
                                        return newrecord$1;
                                      }
                                      var errors = node.parents.map(function (src) {
                                                if (typeof src !== "object" || src.TAG !== "AssertionWithErr") {
                                                  return ;
                                                } else {
                                                  return [
                                                          src.label,
                                                          src.err
                                                        ];
                                                }
                                              }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
                                      var unifErr = errors.length > 0 ? errors.map(function (param) {
                                                var asrtLabel = param[0];
                                                return MM_unification_debug.unifErrToStr(param[1], (function (__x) {
                                                              return MM_context.ctxIntsToStrExn(wrkCtx$1, __x);
                                                            }), (function (expr) {
                                                              return MM_context.frmIntsToStrExn(wrkCtx$1, MM_context.getFrameExn(wrkCtx$1, asrtLabel), expr);
                                                            }));
                                              }).join("\n\n") : undefined;
                                      var newrecord$2 = Caml_obj.obj_dup(stmt$2);
                                      newrecord$2.unifErr = Belt_Option.orElse(stmt$2.unifErr, unifErr);
                                      newrecord$2.proofStatus = "JstfIsIncorrect";
                                      return newrecord$2;
                                    }
                                    var partialAsrtLabels = node.parents.map(function (src) {
                                              if (typeof src !== "object") {
                                                return ;
                                              }
                                              if (src.TAG !== "AssertionWithErr") {
                                                return ;
                                              }
                                              var tmp = src.err;
                                              if (typeof tmp !== "object" || tmp.TAG !== "TooManyCombinations") {
                                                return ;
                                              } else {
                                                return src.label;
                                              }
                                            }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
                                    var unifErr$1 = partialAsrtLabels.length > 0 ? MM_unification_debug.unifErrToStr({
                                            TAG: "TooManyCombinations",
                                            frmLabels: partialAsrtLabels
                                          }, (function (__x) {
                                              return MM_context.ctxIntsToStrExn(wrkCtx$1, __x);
                                            }), (function (param) {
                                              return "<frmExprToStr is not defined>";
                                            })) : undefined;
                                    var newrecord$3 = Caml_obj.obj_dup(stmt$2);
                                    newrecord$3.unifErr = Belt_Option.orElse(stmt$2.unifErr, unifErr$1);
                                    newrecord$3.proofStatus = "NoJstf";
                                    return newrecord$3;
                                  }
                                  throw {
                                        RE_EXN_ID: Common.MmException,
                                        _1: {
                                          msg: "exprToNode->Belt_HashMap.get(expr) is None"
                                        },
                                        Error: new Error()
                                      };
                                }
                                throw {
                                      RE_EXN_ID: Common.MmException,
                                      _1: {
                                        msg: "Cannot applyUnifyAllResults without stmt.expr [2]."
                                      },
                                      Error: new Error()
                                    };
                              }));
                }));
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot applyUnifyAllResults without wrkCtx."
        },
        Error: new Error()
      };
}

function splitIntoChunks(str, chunkMaxSize) {
  var len = str.length;
  if (len <= chunkMaxSize) {
    return [str];
  }
  var res = [];
  var numberOfChunks = Core__Math.Int.ceil(len / chunkMaxSize);
  for(var i = 1; i <= numberOfChunks; ++i){
    var begin = Math.imul(i - 1 | 0, chunkMaxSize);
    res.push(str.substr(begin, chunkMaxSize));
  }
  return res;
}

function proofToText(wrkCtx, typeOrderInDisj, newHyps, newDisj, descr, stmt, proof) {
  if (proof.TAG === "Uncompressed") {
    return "Error: only compressed proofs are supported.";
  }
  var blk = splitIntoChunks(proof.compressedProofBlock, 50).join(" ");
  var asrt = stmt.label + " $p " + contToStr(stmt.cont) + " $= ( " + proof.labels.join(" ") + " ) " + blk + " $.";
  var descrIsEmpty = descr.trim().length === 0;
  var blockIsRequired = newHyps.length > 0 || !MM_context.disjIsEmpty(newDisj) || !descrIsEmpty;
  var result = [];
  if (blockIsRequired) {
    result.push("${");
  }
  var varsArrStr = newHyps.filter(function (hyp) {
          return hyp.typ === "F";
        }).map(function (hyp) {
        return MM_context.ctxIntToSymExn(wrkCtx, hyp.expr[1]);
      });
  if (varsArrStr.length > 0) {
    result.push("$v " + varsArrStr.join(" ") + " $.");
  }
  newHyps.forEach(function (hyp) {
        if (hyp.typ === "F") {
          result.push(hyp.label + " $f " + MM_context.ctxIntsToStrExn(wrkCtx, hyp.expr) + " $.");
          return ;
        }
        
      });
  MM_context.disjForEachArr(newDisj, true, (function (__x) {
          return MM_context.ctxIntToSym(wrkCtx, __x);
        }), (function (__x) {
          return MM_context.getTypeOfVar(wrkCtx, __x);
        }), Caml_option.some(typeOrderInDisj), (function (vars) {
          result.push("$d " + MM_context.ctxIntsToStrExn(wrkCtx, vars) + " $.");
        }));
  newHyps.forEach(function (hyp) {
        if (hyp.typ === "E") {
          result.push(hyp.label + " $e " + MM_context.ctxIntsToStrExn(wrkCtx, hyp.expr) + " $.");
          return ;
        }
        
      });
  if (!descrIsEmpty) {
    result.push("$( " + descr + " $)");
  }
  result.push(asrt);
  if (blockIsRequired) {
    result.push("$}");
  }
  return result.join("\r\n");
}

function generateCompressedProof(st, stmtId, useAllLocalEHypsOpt) {
  var useAllLocalEHyps = useAllLocalEHypsOpt !== undefined ? useAllLocalEHypsOpt : false;
  var wrkCtx = st.wrkCtx;
  if (wrkCtx === undefined) {
    return ;
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  var stmt = editorGetStmtById(st, stmtId);
  if (stmt === undefined) {
    return ;
  }
  var proofTreeDto = stmt.proofTreeDto;
  if (proofTreeDto === undefined) {
    return ;
  }
  var proofNode = stmt.proof;
  if (proofNode === undefined) {
    return ;
  }
  var preCtx = st.preCtx;
  var expr = userStmtToRootStmt(stmt).expr;
  var proofTableWithTypes = MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, undefined, undefined);
  var proofTableWithoutTypes = MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, true, Caml_option.some(wrkCtx$1));
  var exprsUsedInProof = Belt_HashSet.fromArray(proofTableWithTypes.map(function (r) {
            return r.expr;
          }), MM_context.ExprHash);
  var rootStmts = st.stmts.map(userStmtToRootStmt);
  if (useAllLocalEHyps) {
    rootStmts.forEach(function (stmt) {
          if (stmt.isHyp) {
            return Belt_HashSet.add(exprsUsedInProof, stmt.expr);
          }
          
        });
  }
  var proofCtx = MM_provers.createProofCtx(wrkCtx$1, rootStmts.filter(function (stmt) {
            if (stmt.isHyp) {
              return Belt_HashSet.has(exprsUsedInProof, stmt.expr);
            } else {
              return false;
            }
          }));
  var mandHyps = MM_context.getMandHyps(proofCtx, expr, undefined, undefined);
  var proof = MM_proof_table.createProof(mandHyps, proofTableWithTypes, proofTableWithTypes.length - 1 | 0);
  var newHyps = [];
  mandHyps.forEach(function (hyp) {
        if (Belt_Option.isNone(MM_context.getHypByExpr(preCtx, hyp.expr))) {
          newHyps.push(hyp);
          return ;
        }
        
      });
  var varsUsedInProof = Belt_HashSetInt.make(16);
  Belt_HashSet.forEach(exprsUsedInProof, (function (expr) {
          expr.forEach(function (s) {
                if (s >= 0) {
                  return Belt_HashSetInt.add(varsUsedInProof, s);
                }
                
              });
        }));
  var mandVars = Belt_HashSetInt.fromArray(mandHyps.map(function (hyp) {
            return hyp.expr[1];
          }));
  MM_context.getLocalHyps(wrkCtx$1).forEach(function (hyp) {
        if (hyp.typ !== "F") {
          return ;
        }
        var $$var = hyp.expr[1];
        if (Belt_HashSetInt.has(varsUsedInProof, $$var) && !Belt_HashSetInt.has(mandVars, $$var)) {
          newHyps.push(hyp);
          return ;
        }
        
      });
  var newDisj = MM_context.disjMake();
  MM_proof_verifier.verifyProof(proofCtx, expr, proof, (function (n, m) {
          if (!MM_context.isDisj(wrkCtx$1, n, m)) {
            throw {
                  RE_EXN_ID: Common.MmException,
                  _1: {
                    msg: "!(wrkCtx->isDisj(n,m))"
                  },
                  Error: new Error()
                };
          }
          if (!MM_context.isDisj(preCtx, n, m)) {
            MM_context.disjAddPair(newDisj, n, m);
          }
          return true;
        }));
  return [
          proofToText(wrkCtx$1, st.typeOrderInDisj, newHyps, newDisj, st.descr, stmt, proof),
          MM_proof_table.proofTableToStr(wrkCtx$1, proofTableWithTypes, stmt.label),
          MM_proof_table.proofTableToStr(wrkCtx$1, proofTableWithoutTypes, stmt.label)
        ];
}

function replaceRef(st, replaceWhat, replaceWith) {
  return Core__Array.reduce(st.stmts, {
              TAG: "Ok",
              _0: st
            }, (function (res, stmt) {
                if (res.TAG !== "Ok") {
                  return res;
                }
                var st = res._0;
                if (stmt.typ === "E") {
                  return {
                          TAG: "Ok",
                          _0: st
                        };
                }
                var match = parseJstf(stmt.jstfText);
                if (match.TAG !== "Ok") {
                  return {
                          TAG: "Error",
                          _0: "Cannot parse justification '" + stmt.jstfText + "' " + ("for the step '" + stmt.label + "'")
                        };
                }
                var jstf = match._0;
                if (jstf === undefined) {
                  return {
                          TAG: "Ok",
                          _0: st
                        };
                }
                if (!jstf.args.includes(replaceWhat)) {
                  return {
                          TAG: "Ok",
                          _0: st
                        };
                }
                var newJstf_args = jstf.args.map(function (ref) {
                      if (ref === replaceWhat) {
                        return replaceWith;
                      } else {
                        return ref;
                      }
                    });
                var newJstf_label = jstf.label;
                var newJstf = {
                  args: newJstf_args,
                  label: newJstf_label
                };
                return {
                        TAG: "Ok",
                        _0: updateStmt(st, stmt.id, (function (stmt) {
                                var newrecord = Caml_obj.obj_dup(stmt);
                                newrecord.jstfText = MM_statements_dto.jstfToStr(newJstf);
                                return newrecord;
                              }))
                      };
              }));
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

function renameStmt(st, stmtId, newLabel) {
  var newLabel$1 = newLabel.replace(symbolsNotAllowedInLabelRegex, "");
  if (newLabel$1 === "") {
    return {
            TAG: "Error",
            _0: "label must not be empty."
          };
  }
  var match = st.stmts.find(function (stmt) {
        if (stmt.id !== stmtId) {
          return stmt.label === newLabel$1;
        } else {
          return false;
        }
      });
  if (match !== undefined) {
    return {
            TAG: "Error",
            _0: "label '" + newLabel$1 + "' is used by another step."
          };
  }
  var stmt = editorGetStmtById(st, stmtId);
  if (stmt === undefined) {
    return {
            TAG: "Ok",
            _0: st
          };
  }
  if (stmt.label === newLabel$1) {
    return {
            TAG: "Ok",
            _0: st
          };
  }
  var msg = replaceRef(st, stmt.label, newLabel$1);
  if (msg.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: updateStmt(msg._0, stmtId, (function (stmt) {
                    var newrecord = Caml_obj.obj_dup(stmt);
                    newrecord.label = newLabel$1;
                    return newrecord;
                  }))
          };
  } else {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
}

function mergeStmts(st, idToUse, idToDelete) {
  var stmtToUse = editorGetStmtById(st, idToUse);
  if (stmtToUse === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot find a step with id = '" + idToUse + "'"
          };
  }
  var stmtToDelete = editorGetStmtById(st, idToDelete);
  if (stmtToDelete === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot find a step with id = '" + idToDelete + "'"
          };
  }
  if (contToStr(stmtToUse.cont) !== contToStr(stmtToDelete.cont)) {
    return {
            TAG: "Error",
            _0: "Steps to merge must have identical expressions."
          };
  }
  var msg = replaceRef(st, stmtToDelete.label, stmtToUse.label);
  if (msg.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: msg._0
          };
  }
  var st$1 = deleteStmt(msg._0, idToDelete);
  if (!(stmtToDelete.typ === "P" && stmtToDelete.isGoal && stmtToUse.typ !== "E")) {
    return {
            TAG: "Ok",
            _0: st$1
          };
  }
  var st$2 = updateStmt(st$1, idToUse, (function (stmt) {
          var newrecord = Caml_obj.obj_dup(stmt);
          newrecord.isGoal = true;
          newrecord.typ = "P";
          return newrecord;
        }));
  return renameStmt(st$2, idToUse, stmtToDelete.label);
}

var onlyDigitsPattern = /^\d+$/;

function containsOnlyDigits(label) {
  return Belt_Option.isSome(Caml_option.null_to_opt(label.match(onlyDigitsPattern)));
}

function renameHypToMatchGoal(st, oldStmt, newStmt) {
  if (oldStmt.id !== newStmt.id) {
    throw {
          RE_EXN_ID: Common.MmException,
          _1: {
            msg: "renameHypToMatchGoal: oldStmt.id != newStmt.id"
          },
          Error: new Error()
        };
  }
  var stmtId = oldStmt.id;
  if (!(oldStmt.typ === "P" && newStmt.typ === "E" && containsOnlyDigits(newStmt.label))) {
    return st;
  }
  var newLabel = Belt_Option.isSome(st.stmts.find(function (stmt) {
            return stmt.isGoal;
          })) || Belt_Option.isSome(MM_context.getTokenType(st.preCtx, newStmt.label)) ? createNewLabel(st, undefined, true) : newStmt.label;
  if (newLabel === newStmt.label) {
    return st;
  }
  var st$1 = renameStmt(st, stmtId, newLabel);
  if (st$1.TAG === "Ok") {
    return st$1._0;
  } else {
    return st;
  }
}

function completeTypEditMode(st, stmtId, newTyp, newIsGoal) {
  var oldStmt = editorGetStmtByIdExn(st, stmtId);
  var st$1 = updateStmt(st, stmtId, (function (stmt) {
          var newrecord = Caml_obj.obj_dup(stmt);
          var tmp;
          tmp = newTyp === "E" ? false : newIsGoal;
          newrecord.isGoal = tmp;
          newrecord.typEditMode = false;
          newrecord.typ = newTyp;
          return newrecord;
        }));
  var newStmt = editorGetStmtByIdExn(st$1, stmtId);
  return renameHypToMatchGoal(st$1, oldStmt, newStmt);
}

var defaultJstfForHyp = "HYP";

function completeJstfEditMode(st, stmtId, newJstfInp) {
  var oldStmt = editorGetStmtByIdExn(st, stmtId);
  var st$1 = updateStmt(st, stmtId, (function (stmt) {
          var jstfTrimUpperCase = newJstfInp.trim().toLocaleUpperCase();
          var newTyp = jstfTrimUpperCase === defaultJstfForHyp ? "E" : "P";
          var newJstf = jstfTrimUpperCase === defaultJstfForHyp ? "" : newJstfInp.trim();
          var pCnt = Core__Array.reduce(st.stmts, 0, (function (cnt, stmt) {
                  if (stmt.id !== stmtId && stmt.typ === "P") {
                    return cnt + 1 | 0;
                  } else {
                    return cnt;
                  }
                }));
          var newIsGoal = newTyp === "E" ? false : stmt.isGoal || st.settings.initStmtIsGoal && pCnt === 0;
          var newLabel = newIsGoal && !stmt.isGoal && st.settings.defaultStmtLabel.length > 0 ? st.settings.defaultStmtLabel : stmt.label;
          var newrecord = Caml_obj.obj_dup(stmt);
          newrecord.jstfEditMode = false;
          newrecord.jstfText = newJstf;
          newrecord.isGoal = newIsGoal;
          newrecord.typ = newTyp;
          newrecord.label = newLabel;
          return newrecord;
        }));
  var newStmt = editorGetStmtByIdExn(st$1, stmtId);
  return renameHypToMatchGoal(st$1, oldStmt, newStmt);
}

function isHyp(stmtTyp) {
  if (stmtTyp === undefined) {
    return false;
  }
  switch (stmtTyp) {
    case "H" :
        return true;
    case "P" :
    case "G" :
        return false;
    
  }
}

function addStepsWithoutVars(st, atIdx, steps) {
  var updates = [
    (function (st, stmtId, step) {
        var cont = step.cont;
        if (cont !== undefined && cont.trim() !== "") {
          return {
                  TAG: "Ok",
                  _0: completeContEditMode(st, stmtId, cont)
                };
        } else {
          return {
                  TAG: "Error",
                  _0: "Steps must not have empty statements."
                };
        }
      }),
    (function (st, stmtId, step) {
        var label = step.label;
        if (label !== undefined) {
          if (label.trim() === "") {
            return {
                    TAG: "Error",
                    _0: "Steps must not have empty labels."
                  };
          } else {
            return {
                    TAG: "Ok",
                    _0: completeLabelEditMode(st, stmtId, label)
                  };
          }
        } else {
          return {
                  TAG: "Ok",
                  _0: st
                };
        }
      }),
    (function (st, stmtId, step) {
        var typExt = step.typ;
        if (typExt === undefined) {
          return {
                  TAG: "Ok",
                  _0: st
                };
        }
        var match = userStmtTypeExtendedToUserStmtType(typExt);
        return {
                TAG: "Ok",
                _0: completeTypEditMode(st, stmtId, match[0], match[1])
              };
      }),
    (function (st, stmtId, step) {
        var jstf = step.jstf;
        if (jstf !== undefined) {
          return {
                  TAG: "Ok",
                  _0: completeJstfEditMode(st, stmtId, jstf)
                };
        } else {
          return {
                  TAG: "Ok",
                  _0: st
                };
        }
      }),
    (function (st, stmtId, step) {
        var isBkm = step.isBkm;
        if (isBkm !== undefined) {
          return {
                  TAG: "Ok",
                  _0: updateStmt(st, stmtId, (function (stmt) {
                          var newrecord = Caml_obj.obj_dup(stmt);
                          newrecord.isBkm = isBkm;
                          return newrecord;
                        }))
                };
        } else {
          return {
                  TAG: "Ok",
                  _0: st
                };
        }
      })
  ];
  var stmtIds = [];
  var res = Core__Array.reduceWithIndex(steps, {
        TAG: "Ok",
        _0: st
      }, (function (res, step, i) {
          if (res.TAG !== "Ok") {
            return res;
          }
          var st = res._0;
          var match = atIdx !== undefined ? addNewStmtAtIdx(st, atIdx + i | 0, isHyp(step.typ)) : addNewStmt(st, isHyp(step.typ), undefined);
          var stmtId = match[1];
          stmtIds.push(stmtId);
          return Core__Array.reduce(updates, {
                      TAG: "Ok",
                      _0: match[0]
                    }, (function (res, update) {
                        return Belt_Result.flatMap(res, (function (__x) {
                                      return update(__x, stmtId, step);
                                    }));
                      }));
        }));
  if (res.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: [
              res._0,
              stmtIds
            ]
          };
  } else {
    return {
            TAG: "Error",
            _0: res._0
          };
  }
}

function validateVarNames(vars) {
  if (vars.every(function (param) {
          return Belt_Option.isNone(param[1]);
        })) {
    return true;
  } else {
    return vars.every(function (param) {
                return Belt_Option.isSome(param[1]);
              });
  }
}

function addSteps(st, atIdx, steps, varsOpt, dontAddVariablesToContext) {
  var vars = varsOpt !== undefined ? varsOpt : [];
  if (vars.length === 0) {
    return addStepsWithoutVars(st, atIdx, steps);
  }
  var wrkCtx = st.wrkCtx;
  if (wrkCtx === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot add new variables because of errors in the editor."
          };
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  var varTypesStr = vars.map(function (param) {
        return param[0];
      });
  var varTypesOpt = varTypesStr.map(function (__x) {
        return MM_context.ctxSymToInt(wrkCtx$1, __x);
      });
  var unknownTypeIdx = varTypesOpt.findIndex(Belt_Option.isNone);
  if (unknownTypeIdx >= 0) {
    return {
            TAG: "Error",
            _0: "Unknown type - " + varTypesStr[unknownTypeIdx]
          };
  }
  var varTypes = varTypesOpt.map(Belt_Option.getExn);
  if (!validateVarNames(vars)) {
    return {
            TAG: "Error",
            _0: "All variable names must be either defined or undefined."
          };
  }
  var st$1;
  if (vars.some(function (param) {
          return Belt_Option.isNone(param[1]);
        })) {
    st$1 = createNewVars(st, varTypes, undefined, dontAddVariablesToContext)[0];
  } else {
    var varNames = vars.map(function (param) {
          return Belt_Option.getExn(param[1]);
        });
    st$1 = createNewVars(st, varTypes, varNames, dontAddVariablesToContext)[0];
  }
  return addStepsWithoutVars(st$1, atIdx, steps);
}

function updateSteps(st, steps) {
  var updates = [
    (function (stmt, step) {
        var cont = step.cont;
        if (cont === undefined) {
          return {
                  TAG: "Ok",
                  _0: stmt
                };
        }
        if (cont.trim() === "") {
          return {
                  TAG: "Error",
                  _0: "Steps must not have empty statements."
                };
        }
        var newrecord = Caml_obj.obj_dup(stmt);
        return {
                TAG: "Ok",
                _0: (newrecord.isDuplicated = false, newrecord.contEditMode = false, newrecord.cont = strToCont(cont, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors)), newrecord)
              };
      }),
    (function (stmt, step) {
        var typExt = step.typ;
        if (typExt === undefined) {
          return {
                  TAG: "Ok",
                  _0: stmt
                };
        }
        var match = userStmtTypeExtendedToUserStmtType(typExt);
        var newrecord = Caml_obj.obj_dup(stmt);
        return {
                TAG: "Ok",
                _0: (newrecord.isGoal = match[1], newrecord.typEditMode = false, newrecord.typ = match[0], newrecord)
              };
      }),
    (function (stmt, step) {
        var jstf = step.jstf;
        if (jstf === undefined) {
          return {
                  TAG: "Ok",
                  _0: stmt
                };
        }
        var newrecord = Caml_obj.obj_dup(stmt);
        return {
                TAG: "Ok",
                _0: (newrecord.jstfEditMode = false, newrecord.jstfText = jstf, newrecord)
              };
      }),
    (function (stmt, step) {
        var isBkm = step.isBkm;
        if (isBkm === undefined) {
          return {
                  TAG: "Ok",
                  _0: stmt
                };
        }
        var newrecord = Caml_obj.obj_dup(stmt);
        return {
                TAG: "Ok",
                _0: (newrecord.isBkm = isBkm, newrecord)
              };
      })
  ];
  var stmtIdToStepDto = Belt_HashMapString.fromArray(steps.filter(function (step) {
              return Belt_Option.isSome(step.id);
            }).map(function (step) {
            return [
                    Belt_Option.getExn(step.id),
                    step
                  ];
          }));
  var newStmtsRes = Core__Array.reduce(st.stmts, {
        TAG: "Ok",
        _0: []
      }, (function (res, stmt) {
          if (res.TAG !== "Ok") {
            return res;
          }
          var newStmts = res._0;
          var step = Belt_HashMapString.get(stmtIdToStepDto, stmt.id);
          var newStmtRes = step !== undefined ? Core__Array.reduce(updates, {
                  TAG: "Ok",
                  _0: stmt
                }, (function (res, update) {
                    return Belt_Result.flatMap(res, (function (__x) {
                                  return update(__x, step);
                                }));
                  })) : ({
                TAG: "Ok",
                _0: stmt
              });
          if (newStmtRes.TAG !== "Ok") {
            return {
                    TAG: "Error",
                    _0: newStmtRes._0
                  };
          }
          newStmts.push(newStmtRes._0);
          return {
                  TAG: "Ok",
                  _0: newStmts
                };
        }));
  if (newStmtsRes.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: newStmtsRes._0
          };
  }
  var newrecord = Caml_obj.obj_dup(st);
  return {
          TAG: "Ok",
          _0: (newrecord.stmts = newStmtsRes._0, newrecord)
        };
}

function findStmtsToMerge(st) {
  var stmt1;
  if (st.checkedStmtIds.length === 0) {
    stmt1 = st.stmts.find(function (stmt) {
          return Belt_Option.getWithDefault(Belt_Option.map(stmt.stmtErr, (function (err) {
                            return err.code === 1;
                          })), false);
        });
  } else {
    var match = st.checkedStmtIds[0];
    stmt1 = editorGetStmtById(st, match[0]);
  }
  if (stmt1 === undefined) {
    return {
            TAG: "Error",
            _0: "[1] Cannot determine a duplicated step."
          };
  }
  var contStr = contToStr(stmt1.cont);
  var stmt2 = st.stmts.find(function (stmt) {
        if (stmt.id !== stmt1.id) {
          return contToStr(stmt.cont) === contStr;
        } else {
          return false;
        }
      });
  if (stmt2 === undefined) {
    return {
            TAG: "Error",
            _0: "[2] Cannot find another step to merge with."
          };
  }
  var idx1 = st.stmts.findIndex(function (stmt) {
        return stmt.id === stmt1.id;
      });
  var idx2 = st.stmts.findIndex(function (stmt) {
        return stmt.id === stmt2.id;
      });
  if (idx1 < idx2) {
    return {
            TAG: "Ok",
            _0: [
              stmt1,
              stmt2
            ]
          };
  } else {
    return {
            TAG: "Ok",
            _0: [
              stmt2,
              stmt1
            ]
          };
  }
}

function findFirstDuplicatedStmt(st) {
  return st.stmts.find(function (stmt) {
              if (stmt.isDuplicated) {
                return false;
              } else {
                return Belt_Option.getWithDefault(Belt_Option.map(stmt.stmtErr, (function (err) {
                                  return err.code === 1;
                                })), false);
              }
            });
}

function findSecondDuplicatedStmt(st, stmt1) {
  var contStr = contToStr(stmt1.cont);
  return st.stmts.find(function (stmt2) {
              if (!stmt2.isDuplicated && stmt2.id !== stmt1.id) {
                return contToStr(stmt2.cont) === contStr;
              } else {
                return false;
              }
            });
}

function autoMergeDuplicatedStatements(st, selectFirst) {
  var renames = [];
  var resultState = st;
  var $$continue = true;
  while($$continue) {
    var stmt1 = findFirstDuplicatedStmt(resultState);
    if (stmt1 !== undefined) {
      var stmt2 = findSecondDuplicatedStmt(resultState, stmt1);
      if (stmt2 !== undefined) {
        var jstf1 = stmt1.jstfText.trim();
        var jstf2 = stmt2.jstfText.trim();
        if (selectFirst) {
          if (jstf1 === "") {
            $$continue = false;
          } else {
            var stateAfterMerge = mergeStmts(resultState, stmt2.id, stmt1.id);
            if (stateAfterMerge.TAG === "Ok") {
              renames.push([
                    stmt1.label,
                    stmt2.label
                  ]);
              resultState = prepareEditorForUnification(stateAfterMerge._0);
            } else {
              $$continue = false;
            }
          }
        } else if (jstf1 !== "" && jstf2 === "") {
          var stateAfterMerge$1 = mergeStmts(resultState, stmt1.id, stmt2.id);
          if (stateAfterMerge$1.TAG === "Ok") {
            renames.push([
                  stmt2.label,
                  stmt1.label
                ]);
            resultState = prepareEditorForUnification(stateAfterMerge$1._0);
          } else {
            $$continue = false;
          }
        } else if (jstf2 !== "" && (jstf1 === "" || jstf1 === jstf2)) {
          var stateAfterMerge$2 = mergeStmts(resultState, stmt2.id, stmt1.id);
          if (stateAfterMerge$2.TAG === "Ok") {
            renames.push([
                  stmt1.label,
                  stmt2.label
                ]);
            resultState = prepareEditorForUnification(stateAfterMerge$2._0);
          } else {
            $$continue = false;
          }
        } else {
          $$continue = false;
        }
      } else {
        $$continue = false;
      }
    } else {
      $$continue = false;
    }
  };
  return [
          resultState,
          renames
        ];
}

function verifyEditorState(st) {
  var st$1 = prepareEditorForUnification(st);
  if (!Belt_Option.isSome(st$1.wrkCtx)) {
    return st$1;
  }
  var st$2 = removeUnusedVars(st$1);
  var st$3 = st$2.settings.autoMergeStmts ? autoMergeDuplicatedStatements(st$2, false)[0] : st$2;
  return prepareEditorForUnification(st$3);
}

function getSelectedSubtree(treeData) {
  var match = treeData.clickedNodeId;
  if (match === undefined) {
    return ;
  }
  var match$1 = MM_syntax_tree.getNodeById(treeData.root, match[0]);
  if (match$1 === undefined) {
    return ;
  }
  if (match$1.TAG === "Subtree") {
    return ;
  }
  var parent = match$1.parent;
  if (treeData.expLvl === 0) {
    return {
            TAG: "Symbol",
            id: match$1.id,
            parent: parent,
            symInt: match$1.symInt,
            sym: match$1.sym,
            color: match$1.color,
            isVar: match$1.isVar
          };
  }
  var curParent = parent;
  var curLvl = treeData.expLvl;
  while(curLvl > 1 && Belt_Option.isSome(curParent)) {
    curLvl = curLvl - 1 | 0;
    curParent = Belt_Option.getExn(curParent).parent;
  };
  var parent$1 = curParent;
  if (parent$1 !== undefined) {
    return {
            TAG: "Subtree",
            _0: parent$1
          };
  } else {
    return {
            TAG: "Subtree",
            _0: treeData.root
          };
  }
}

function getStmtContTreeData(stmtCont) {
  if (stmtCont.TAG === "Text") {
    return ;
  } else {
    return stmtCont._0;
  }
}

function getSelectedSubtreeFromStmtCont(stmtCont) {
  return Belt_Option.flatMap(getStmtContTreeData(stmtCont), getSelectedSubtree);
}

function getNumberOfSelectedSymbols(treeData) {
  return Belt_Option.getWithDefault(Belt_Option.map(getSelectedSubtree(treeData), MM_syntax_tree.syntaxTreeGetNumberOfSymbols), 0);
}

function getIdsOfSelectedNodes(stmtCont) {
  if (stmtCont.TAG === "Text") {
    return [
            -1,
            undefined
          ];
  }
  var treeData = stmtCont._0;
  var match = treeData.clickedNodeId;
  if (match === undefined) {
    return [
            -1,
            undefined
          ];
  }
  var selectedSubtree = getSelectedSubtree(treeData);
  if (selectedSubtree !== undefined) {
    return [
            match[0],
            MM_syntax_tree.syntaxTreeGetIdsOfAllChildSymbols(selectedSubtree)
          ];
  } else {
    return [
            -1,
            undefined
          ];
  }
}

function getNodeIdBySymIdx(symIdx, tree) {
  var cnt = {
    contents: 0
  };
  return MM_syntax_tree.syntaxTreeForEachNode({
              TAG: "Subtree",
              _0: tree
            }, (function (node) {
                if (node.TAG === "Subtree") {
                  return ;
                }
                cnt.contents = cnt.contents + 1 | 0;
                if (cnt.contents === symIdx) {
                  return node.id;
                }
                
              }));
}

function hasSelectedText(stmtCont) {
  if (stmtCont.TAG === "Text") {
    return false;
  } else {
    return stmtCont._0.clickedNodeId !== undefined;
  }
}

function getSelectedText(stmtCont) {
  if (stmtCont.TAG === "Text") {
    return ;
  } else {
    return Belt_Option.map(getSelectedSubtree(stmtCont._0), MM_syntax_tree.syntaxTreeToText);
  }
}

function incExpLvl(treeData) {
  return {
          text: treeData.text,
          exprTyp: treeData.exprTyp,
          root: treeData.root,
          clickedNodeId: treeData.clickedNodeId,
          expLvl: Math.min(treeData.expLvl + 1 | 0, treeData.root.height)
        };
}

function decExpLvl(treeData) {
  return {
          text: treeData.text,
          exprTyp: treeData.exprTyp,
          root: treeData.root,
          clickedNodeId: treeData.clickedNodeId,
          expLvl: Math.max(treeData.expLvl - 1 | 0, 0)
        };
}

function getAllExprsToSyntaxCheck(st, rootStmts) {
  var res = [];
  st.stmts.forEach(function (stmt, i) {
        var match = stmt.cont;
        if (match.TAG !== "Text") {
          return ;
        }
        res.push(rootStmts[i].expr.slice(1));
      });
  return res;
}

function updateExpLevel(treeData, inc) {
  var update = inc ? incExpLvl : decExpLvl;
  var prevTreeData = treeData;
  var prevNum = getNumberOfSelectedSymbols(prevTreeData);
  var newTreeData = update(prevTreeData);
  var newNum = getNumberOfSelectedSymbols(newTreeData);
  while(prevNum === newNum && (inc && newTreeData.expLvl < newTreeData.root.height || !inc && newTreeData.expLvl > 0)) {
    prevTreeData = newTreeData;
    prevNum = getNumberOfSelectedSymbols(prevTreeData);
    newTreeData = update(prevTreeData);
    newNum = getNumberOfSelectedSymbols(newTreeData);
  };
  return newTreeData;
}

function incExpLvlIfConstClicked(treeData) {
  if (treeData.expLvl !== 0) {
    return treeData;
  }
  var match = treeData.clickedNodeId;
  if (match === undefined) {
    return treeData;
  }
  var match$1 = MM_syntax_tree.getNodeById(treeData.root, match[0]);
  if (match$1 !== undefined && !(match$1.TAG === "Subtree" || MM_syntax_tree.syntaxTreeGetNumberOfSymbols({
            TAG: "Subtree",
            _0: match$1.parent
          }) === 1)) {
    return updateExpLevel(treeData, true);
  } else {
    return treeData;
  }
}

function renumberSteps(state, isStmtToRenumber, prefix, forHyp) {
  var state$1 = prepareEditorForUnification(state);
  if (editorStateHasCriticalErrors(state$1)) {
    return {
            TAG: "Error",
            _0: "Cannot perform renumbering because there is an error in the editor content. Please resolve the error before renumbering."
          };
  }
  var idsToRenumberArr = state$1.stmts.filter(isStmtToRenumber).map(function (stmt) {
        return stmt.id;
      });
  var idsToRenumberSet = Belt_HashSetString.fromArray(idsToRenumberArr);
  var res = Core__Array.reduce(state$1.stmts, {
        TAG: "Ok",
        _0: state$1
      }, (function (res, stmt) {
          if (res.TAG !== "Ok") {
            return res;
          }
          var st = res._0;
          if (Belt_HashSetString.has(idsToRenumberSet, stmt.id)) {
            return renameStmt(st, stmt.id, "###tmp###" + stmt.label);
          } else {
            return {
                    TAG: "Ok",
                    _0: st
                  };
          }
        }));
  var res$1 = Core__Array.reduce(idsToRenumberArr, res, (function (res, stmtId) {
          if (res.TAG !== "Ok") {
            return res;
          }
          var st = res._0;
          return renameStmt(st, stmtId, createNewLabel(st, prefix, forHyp));
        }));
  if (res$1.TAG !== "Ok") {
    return res$1;
  }
  var state$2 = prepareEditorForUnification(res$1._0);
  if (editorStateHasCriticalErrors(state$2)) {
    return {
            TAG: "Error",
            _0: "Cannot renumber steps due to an internal error. An error was detected in the editor content after a renumbering attempt. All errors detected are: " + editorStateGetTextDescriptionOfAllCriticalErrors(state$2)
          };
  } else {
    return {
            TAG: "Ok",
            _0: state$2
          };
  }
}

function renumberProvableSteps(state) {
  return renumberSteps(state, (function (stmt) {
                if (stmt.typ === "P" && !stmt.isGoal) {
                  return containsOnlyDigits(stmt.label);
                } else {
                  return false;
                }
              }), "", false);
}

function renumberHypothesisSteps(state, goalLabel) {
  return renumberSteps(state, (function (stmt) {
                return stmt.typ === "E";
              }), goalLabel + ".", true);
}

function textToSyntaxProofTable(wrkCtx, syms, syntaxTypes, frms, frameRestrict, parenCnt, lastSyntaxType, onLastSyntaxTypeChange) {
  if (syntaxTypes.length === 0) {
    return {
            TAG: "Error",
            _0: "Could not determine syntax types."
          };
  }
  var findUndefinedSym = function (syms) {
    return syms.find(function (sym) {
                return Belt_Option.isNone(MM_context.ctxSymToInt(wrkCtx, sym));
              });
  };
  var unrecognizedSymbol = findUndefinedSym(Belt_Array.concatMany(syms));
  if (unrecognizedSymbol !== undefined) {
    return {
            TAG: "Error",
            _0: "Unrecognized symbol: '" + unrecognizedSymbol + "'"
          };
  }
  var lastSyntaxTypeInt = Belt_Option.getWithDefault(Belt_Option.flatMap(lastSyntaxType, (function (__x) {
              return MM_context.ctxSymToInt(wrkCtx, __x);
            })), 0);
  var syntaxTypes$1 = Expln_utils_common.sortInPlaceWith(syntaxTypes.slice(), (function (a, b) {
          if (a === lastSyntaxTypeInt) {
            return -1.0;
          } else if (b === lastSyntaxTypeInt) {
            return 1.0;
          } else {
            return a - b | 0;
          }
        }));
  var exprs = syms.map(function (__x) {
        return MM_context.ctxSymsToIntsExn(wrkCtx, __x);
      });
  var proofTree = MM_provers.proveSyntaxTypes(undefined, Caml_option.some(wrkCtx), Caml_option.some(frms), frameRestrict, Caml_option.some(parenCnt), exprs, syntaxTypes$1, undefined);
  var typeStmts = exprs.map(function (expr) {
        var node = MM_proof_tree.ptGetSyntaxProof(proofTree, expr);
        if (node !== undefined) {
          return MM_proof_tree.pnGetExpr(Caml_option.valFromOption(node));
        }
        
      });
  var proofTreeDto = MM_proof_tree_dto.proofTreeToDto(proofTree, typeStmts.filter(Belt_Option.isSome).map(Belt_Option.getExn));
  var match = typeStmts.find(Belt_Option.isSome);
  if (match !== undefined) {
    var typeStmt = Caml_option.valFromOption(match);
    if (typeStmt !== undefined) {
      if (lastSyntaxType !== undefined) {
        Belt_Option.forEach(MM_context.ctxIntToSym(wrkCtx, typeStmt[0]), (function (provedSyntaxType) {
                if (lastSyntaxType !== provedSyntaxType) {
                  return onLastSyntaxTypeChange(provedSyntaxType);
                }
                
              }));
      } else {
        Belt_Option.forEach(MM_context.ctxIntToSym(wrkCtx, typeStmt[0]), onLastSyntaxTypeChange);
      }
    }
    
  }
  return {
          TAG: "Ok",
          _0: typeStmts.map(function (typeStmt) {
                if (typeStmt !== undefined) {
                  return MM_syntax_tree.buildSyntaxProofTableFromProofTreeDto(wrkCtx, proofTreeDto, typeStmt);
                } else {
                  return {
                          TAG: "Error",
                          _0: "Could not prove this statement is of any of the types: " + MM_context.ctxIntsToSymsExn(wrkCtx, syntaxTypes$1).join(", ")
                        };
                }
              })
        };
}

function textToSyntaxTree(wrkCtx, syms, syntaxTypes, frms, frameRestrict, parenCnt, lastSyntaxType, onLastSyntaxTypeChange) {
  var syntaxProofTables = textToSyntaxProofTable(wrkCtx, syms, syntaxTypes, frms, frameRestrict, parenCnt, lastSyntaxType, onLastSyntaxTypeChange);
  if (syntaxProofTables.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: syntaxProofTables._0.map(function (proofTable) {
                  if (proofTable.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: proofTable._0
                          };
                  }
                  var proofTable$1 = proofTable._0;
                  return MM_syntax_tree.buildSyntaxTree(wrkCtx, proofTable$1, proofTable$1.length - 1 | 0);
                })
          };
  } else {
    return {
            TAG: "Error",
            _0: syntaxProofTables._0
          };
  }
}

function resetEditorContent(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = [];
  newrecord.disjEditMode = false;
  newrecord.disjText = "";
  newrecord.varsEditMode = false;
  newrecord.varsText = "";
  newrecord.descrEditMode = false;
  newrecord.descr = "";
  return newrecord;
}

function deleteUnrelatedSteps(state, stepIdsToKeep, deleteHyps) {
  var state$1 = prepareEditorForUnification(state);
  if (editorStateHasCriticalErrors(state$1)) {
    return {
            TAG: "Error",
            _0: "Cannot perform deletion because there is an error in the editor content. Please resolve the error before deleting steps."
          };
  }
  var unprocessedIds = Belt_MutableQueue.fromArray(stepIdsToKeep);
  state$1.stmts.forEach(function (stmt) {
        if (!deleteHyps && stmt.typ === "E" || stmt.isGoal || stmt.isBkm) {
          return Belt_MutableQueue.add(unprocessedIds, stmt.id);
        }
        
      });
  var idsToKeep = Belt_HashSetString.make(Math.imul(stepIdsToKeep.length, 5));
  while(!Belt_MutableQueue.isEmpty(unprocessedIds)) {
    var idToKeep = Belt_Option.getExn(Belt_MutableQueue.pop(unprocessedIds));
    if (!Belt_HashSetString.has(idsToKeep, idToKeep)) {
      Belt_HashSetString.add(idsToKeep, idToKeep);
      var stmtToProcess = editorGetStmtById(state$1, idToKeep);
      if (stmtToProcess !== undefined) {
        var match = stmtToProcess.jstf;
        if (match !== undefined) {
          match.args.forEach(function (label) {
                var stmt = editorGetStmtByLabel(state$1, label);
                if (stmt !== undefined) {
                  return Belt_MutableQueue.add(unprocessedIds, stmt.id);
                }
                
              });
        }
        
      }
      
    }
    
  };
  var idsToRemove = state$1.stmts.map(function (stmt) {
          return stmt.id;
        }).filter(function (id) {
        return !Belt_HashSetString.has(idsToKeep, id);
      });
  return {
          TAG: "Ok",
          _0: deleteStmts(state$1, idsToRemove)
        };
}

var someStmtErrCode = -1;

var duplicatedStmtErrCode = 1;

exports.defaultJstfForHyp = defaultJstfForHyp;
exports.contIsEmpty = contIsEmpty;
exports.contToArrStr = contToArrStr;
exports.contToStr = contToStr;
exports.strToCont = strToCont;
exports.userStmtTypeFromStr = userStmtTypeFromStr;
exports.userStmtTypeToStr = userStmtTypeToStr;
exports.userStmtTypeExtendedFromStrExn = userStmtTypeExtendedFromStrExn;
exports.readInstrToStr = readInstrToStr;
exports.readInstrFromStr = readInstrFromStr;
exports.mmFileSourceTypeToStr = mmFileSourceTypeToStr;
exports.mmFileSourceTypeFromStr = mmFileSourceTypeFromStr;
exports.mmFileSourceTypeFromStrOpt = mmFileSourceTypeFromStrOpt;
exports.someStmtErrCode = someStmtErrCode;
exports.duplicatedStmtErrCode = duplicatedStmtErrCode;
exports.createEmptyUserStmt = createEmptyUserStmt;
exports.userStmtToRootStmt = userStmtToRootStmt;
exports.updateStmt = updateStmt;
exports.isStmtChecked = isStmtChecked;
exports.toggleStmtChecked = toggleStmtChecked;
exports.toggleStmtCheckedWithShift = toggleStmtCheckedWithShift;
exports.checkAllStmts = checkAllStmts;
exports.uncheckAllStmts = uncheckAllStmts;
exports.deleteCheckedStmts = deleteCheckedStmts;
exports.deleteStmt = deleteStmt;
exports.deleteStmts = deleteStmts;
exports.canMoveCheckedStmts = canMoveCheckedStmts;
exports.moveCheckedStmts = moveCheckedStmts;
exports.moveCheckedStmtsToTop = moveCheckedStmtsToTop;
exports.moveCheckedStmtsToBottom = moveCheckedStmtsToBottom;
exports.getRootStmtsForUnification = getRootStmtsForUnification;
exports.addNewStmt = addNewStmt;
exports.addNewStatements = addNewStatements;
exports.isSingleStmtChecked = isSingleStmtChecked;
exports.duplicateCheckedStmt = duplicateCheckedStmt;
exports.bookmarkCheckedStmts = bookmarkCheckedStmts;
exports.canGoEditModeForStmt = canGoEditModeForStmt;
exports.setDescrEditMode = setDescrEditMode;
exports.completeDescrEditMode = completeDescrEditMode;
exports.setVarsEditMode = setVarsEditMode;
exports.completeVarsEditMode = completeVarsEditMode;
exports.setDisjEditMode = setDisjEditMode;
exports.completeDisjEditMode = completeDisjEditMode;
exports.setLabelEditMode = setLabelEditMode;
exports.completeLabelEditMode = completeLabelEditMode;
exports.setContEditMode = setContEditMode;
exports.completeContEditMode = completeContEditMode;
exports.setStmtCont = setStmtCont;
exports.setTypEditMode = setTypEditMode;
exports.completeTypEditMode = completeTypEditMode;
exports.setJstfEditMode = setJstfEditMode;
exports.completeJstfEditMode = completeJstfEditMode;
exports.setNextAction = setNextAction;
exports.setPreCtxData = setPreCtxData;
exports.editorStateHasCriticalErrors = editorStateHasCriticalErrors;
exports.editorStateHasAnyErrors = editorStateHasAnyErrors;
exports.editorStateHasDuplicatedStmts = editorStateHasDuplicatedStmts;
exports.createNewDisj = createNewDisj;
exports.removeUnusedVars = removeUnusedVars;
exports.applyUnifyAllResults = applyUnifyAllResults;
exports.verifyEditorState = verifyEditorState;
exports.generateCompressedProof = generateCompressedProof;
exports.updateColorsInAllStmts = updateColorsInAllStmts;
exports.getTheOnlyCheckedStmt = getTheOnlyCheckedStmt;
exports.editorGetStmtById = editorGetStmtById;
exports.editorGetStmtByIdExn = editorGetStmtByIdExn;
exports.editorGetStmtByLabel = editorGetStmtByLabel;
exports.getAllExprsToSyntaxCheck = getAllExprsToSyntaxCheck;
exports.mergeStmts = mergeStmts;
exports.renameStmt = renameStmt;
exports.findStmtsToMerge = findStmtsToMerge;
exports.parseJstf = parseJstf;
exports.removeAllTempData = removeAllTempData;
exports.isEditMode = isEditMode;
exports.resetEditorContent = resetEditorContent;
exports.deleteUnrelatedSteps = deleteUnrelatedSteps;
exports.autoMergeDuplicatedStatements = autoMergeDuplicatedStatements;
exports.userStmtHasCriticalErrors = userStmtHasCriticalErrors;
exports.userStmtHasAnyErrors = userStmtHasAnyErrors;
exports.createNewVars = createNewVars;
exports.addSteps = addSteps;
exports.updateSteps = updateSteps;
exports.getSelectedSubtree = getSelectedSubtree;
exports.getSelectedSubtreeFromStmtCont = getSelectedSubtreeFromStmtCont;
exports.getIdsOfSelectedNodes = getIdsOfSelectedNodes;
exports.hasSelectedText = hasSelectedText;
exports.getSelectedText = getSelectedText;
exports.getNodeIdBySymIdx = getNodeIdBySymIdx;
exports.incExpLvl = incExpLvl;
exports.decExpLvl = decExpLvl;
exports.incExpLvlIfConstClicked = incExpLvlIfConstClicked;
exports.getNumberOfSelectedSymbols = getNumberOfSelectedSymbols;
exports.updateExpLevel = updateExpLevel;
exports.addColorsToSyntaxTree = addColorsToSyntaxTree;
exports.getColorForSymbol = getColorForSymbol;
exports.createSymbolColors = createSymbolColors;
exports.renumberProvableSteps = renumberProvableSteps;
exports.renumberHypothesisSteps = renumberHypothesisSteps;
exports.textToSyntaxProofTable = textToSyntaxProofTable;
exports.textToSyntaxTree = textToSyntaxTree;
exports.recalcWrkColors = recalcWrkColors;
/* Common Not a pure module */
